import React, { useContext, useEffect, useRef, useState } from "react";
import AdminContext from "../../StateContext/Application";
import { apiurl } from "../../../../path";
import "./rejectpanel.css";
import { useLanguage } from "../../../../lang/langcontext/LanguageContext";
import Select from "react-select";

const ProgressReport = () => {
  const submitLockRef = useRef(false);
  const { language, toggleLanguage, t } = useLanguage();
  const context = useContext(AdminContext);
  const {
    GetAllWorkOrderList,
    UploadFDUTF,
    GetPrograsslist,
    GetBudgetHeadInfo,
    GetTechnicalInwardsList,
  } = context;
  const [showPopup, setShowPopup] = useState(false);
  const [showDetail, setShowDetail] = useState(false);
  const [selectedProposal, setSelectedProposal] = useState(null);
  const [proposallist, setProposalList] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredBills, setFilteredBills] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const billsPerPage = 10;
  const [releaseFiles, setReleaseFiles] = useState({});
  const [selectedImages, setSelectedImages] = useState([]);
  const [progressPhoto, setProgressPhoto] = useState([]);
  // Filter states
  const [filterHeadCode, setFilterHeadCode] = useState("");
  const [filterProposalYear, setFilterProposalYear] = useState("");
  const [selectedProposals, setSelectedProposals] = useState([]);
  const [filterWorkOrderId, setFilterWorkOrderId] = useState("");
  const [physicalWorkPercentage, setPhysicalWorkPercentage] = useState("");
  const [remarks, setRemarks] = useState("");
  const [filterTechnicalUID, setFilterTechnicalUID] = useState("");
  const [filterCommonWorkOrderId, setFilterCommonWorkOrderId] = useState("");
  const [declarationChecked, setDeclarationChecked] = useState(false);
  const [lastPhysicalValue, setLastPhysicalValue] = useState(0);
  const [availableHeadCodes, setavailableHeadCodes] = useState([]);
  const [technicalInwards, setTechnicalInwards] = useState([]);
  const [isDisabledSubmit, setIsDisabledSubmit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [completedProgress, setCompletedProgress] = useState(null);
  const [MHUIDNo, setMHUIDNo] = useState("");
  const [error, setError] = useState("");
  const [workOrderType, setWorkOrderType] = useState("");

  console.log("proposallist: ", proposallist);
  console.log("progress photo: ", progressPhoto);
  console.log("filterHeadCode: ", filterHeadCode);

  // console.log("progress photo: ", progressPhoto);

  const headerStyle = {
    padding: "9px 12px",
    whiteSpace: "nowrap",
    borderRight: "1px solid #e0e0e0",
    textTransform: "capitalize",
  };

  const proposalEstimate = async () => {
    let data = await GetAllWorkOrderList();
    console.log("proposal data", data);
    setProposalList(data);
  };

  const gettingProgressList = async () => {
    let previousPhoto = await GetPrograsslist();

    const filteredPhotos = previousPhoto.filter((item) =>
      workOrderType === "Existing Work Order"
        ? item.CommonWorkOrderID === filterCommonWorkOrderId
        : item.TechnicalUID === filterTechnicalUID,
    );

    console.log("check physical", previousPhoto);

    const photoData = filteredPhotos.map((item) => ({
      id: item.ID,
      uploadID: item.UploadID,
      upload: item.Upload,
      physicalValue: item.physicalValue,
      technicalUID: item.TechnicalUID,
      headCode: item.Head_Code,
      workOrderNo: item.WorkOrderNo,
      status: item.Status,
      commonWorkOrderId: item.CommonWorkOrderID,
    }));
    setProgressPhoto(photoData);

    const lastEntry = filteredPhotos.at(-1);
    setLastPhysicalValue(lastEntry ? Number(lastEntry.physicalValue) : 0);
  };

  const FetchHeadInfo = async () => {
    try {
      let res = await GetBudgetHeadInfo("null", "all");
      console.log("Data i get from Bakcend :: ", res);
      setavailableHeadCodes(res);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    proposalEstimate();
    FetchHeadInfo();
  }, []);

  useEffect(() => {
    console.log("Filter values:", {
      filterHeadCode,
      filterProposalYear,
      filterCommonWorkOrderId,
      filterWorkOrderId,
      filterTechnicalUID,
    });
    console.log("Filtered bills:", filteredBills);
    // ... rest of your code
  }, [
    proposallist,
    filterHeadCode,
    filterProposalYear,
    filterCommonWorkOrderId,
    filterWorkOrderId,
    searchTerm,
    filterTechnicalUID,
  ]);

  useEffect(() => {
    // if (
    //   workOrderType === "Existing Work Order"
    //     ? filterCommonWorkOrderId
    //     : filterTechnicalUID
    // ) {
      gettingProgressList();
    // }
  }, [filterTechnicalUID, filterCommonWorkOrderId, workOrderType]);

  useEffect(() => {
    let filtered = [...proposallist];

    const dataAfterHeadCode = filterHeadCode
      ? proposallist.filter(
          (item) => String(item.HeadCode) === String(filterHeadCode),
        )
      : proposallist;

    const dataAfterYear = filterProposalYear
      ? dataAfterHeadCode.filter(
          (item) => String(item.ProposalYear) === String(filterProposalYear),
        )
      : dataAfterHeadCode;

    const dataAfterCommonWorkOrder = filterCommonWorkOrderId
      ? dataAfterYear.filter(
          (item) =>
            String(item.CommonWorkOrderID) === String(filterCommonWorkOrderId),
        )
      : dataAfterYear;

    const dataAfterWorkOrder = filterWorkOrderId
      ? dataAfterCommonWorkOrder.filter(
          (item) => String(item.WorkOrderID) === String(filterWorkOrderId),
        )
      : dataAfterCommonWorkOrder;

    if (workOrderType === "Existing Work Order") {
      filtered = dataAfterWorkOrder.filter(
        (item) => item.WorkOrderType === "Existing Work Order",
      );
    } else {
      if (filterTechnicalUID && filterTechnicalUID !== "") {
        filtered = dataAfterWorkOrder.filter(
          (item) => String(item.TechnicalUID) === String(filterTechnicalUID),
        );
      } else {
        filtered = dataAfterWorkOrder;
      }
    }

    if (searchTerm) {
      const lowerSearchTerm = searchTerm.toLowerCase();
      filtered = filtered.filter((bill) =>
        Object.values(bill).some((val) =>
          (val || "").toString().toLowerCase().includes(lowerSearchTerm),
        ),
      );
    }

    setFilteredBills(filtered);
    setSelectedProposals([]);
  }, [
    proposallist,
    filterHeadCode,
    filterProposalYear,
    filterCommonWorkOrderId,
    filterWorkOrderId,
    searchTerm,
    filterTechnicalUID,
  ]);

  useEffect(() => {
    setCurrentPage(1);
  }, [filterHeadCode, filterCommonWorkOrderId, filterProposalYear, searchTerm]);

  useEffect(() => {
    if (selectedProposals.length === 1) {
      const proposal = proposallist.find(
        (p) => p.WorkOrderID === selectedProposals[0],
      );
      setSelectedProposal(proposal);
    } else {
      setSelectedProposal(null);
    }
  }, [selectedProposals]);

  // const availableHeadCodes = [...new Set(proposallist.map(item => item.HeadCode))].filter(Boolean);

  const availableProposalYears = filterHeadCode
    ? [
        ...new Set(
          proposallist
            .filter((i) => i.HeadCode === filterHeadCode)
            .map((i) => i.ProposalYear),
        ),
      ].filter(Boolean)
    : [];

  const availableCommonWorkOrderIds = proposallist
    .filter((i) => {
      // COMMON FILTERS
      const commonMatch =
        String(i.HeadCode || "") === String(filterHeadCode) &&
        String(i.ProposalYear || "") === String(filterProposalYear);

      // EXISTING WORK ORDER
      if (workOrderType === "Existing Work Order") {
        return commonMatch && i.WorkOrderType === "Existing Work Order";
      }

      // NEW WORK ORDER
      return (
        commonMatch &&
        i.WorkOrderType !== "Existing Work Order" &&
        String(i.TechnicalUID || "") === String(filterTechnicalUID)
      );
    })
    .reduce((acc, i) => {
      if (
        i.CommonWorkOrderID &&
        !acc.find((item) => item.id === i.CommonWorkOrderID)
      ) {
        acc.push({
          id: i.CommonWorkOrderID,
          name: i.WorkName,
        });
      }

      return acc;
    }, []);

  const availableWorkOrderIds = filterCommonWorkOrderId
    ? proposallist
        .filter(
          (i) =>
            String(i.CommonWorkOrderID || "") ===
            String(filterCommonWorkOrderId),
        )
        .reduce((acc, i) => {
          // avoid duplicates
          if (!acc.find((item) => item.id === i.WorkOrderID)) {
            acc.push({
              id: i.WorkOrderID,
              name: i.Workorder_ProposalID,
            });
          }
          return acc;
        }, [])
    : [];

  // const availableTechnicalUIDs = filterProposalYear
  //   ? [...new Set(
  //     proposallist
  //       .filter(i =>
  //         String(i.HeadCode || '') === String(filterHeadCode) &&
  //         String(i.ProposalYear || '') === String(filterProposalYear)
  //         // String(i.CommonWorkOrderID || '') === String(filterCommonWorkOrderId)
  //         // String(i.WorkOrderID || '') === String(filterWorkOrderId)
  //       )
  //       .map(i => i.TechnicalUID)
  //   )].filter(Boolean)
  //   : [];

  const availableTechnicalUIDs = filterProposalYear
    ? [
        ...new Set(
          proposallist
            .filter(
              (i) =>
                String(i.HeadCode || "") === String(filterHeadCode) &&
                String(i.ProposalYear || "") === String(filterProposalYear) &&
                i.WorkOrderType === "New Work Order" &&
                i.TechnicalUID &&
                String(i.TechnicalUID).trim() !== "" &&
                String(i.TechnicalUID).trim().toUpperCase() !== "NULL",
            )
            .map((i) => i.TechnicalUID),
        ),
      ]
    : [];
  const totalPages = Math.ceil(filteredBills.length / billsPerPage);
  const indexOfLastBill = currentPage * billsPerPage;
  const indexOfFirstBill = indexOfLastBill - billsPerPage;
  const currentBills = filteredBills?.slice(indexOfFirstBill, indexOfLastBill);

  // Updated: Auto-select row when clicked
  const handleRowClick = (workOrderID) => {
    setSelectedProposals([workOrderID]);
  };

  const handleSubmitSelectedProposals = async (e) => {
    e.preventDefault();

    // Mandatory field checks
    if (!filterHeadCode) {
      alert("Please select Head Code (required)!");
      return;
    }
    if (!filterProposalYear) {
      alert("Please select Approval Year (required)!");
      return;
    }
    if (workOrderType !== "Existing Work Order" && !filterTechnicalUID) {
      alert("Please select Technical Sanction Number (required)!");
      return;
    }
    if (!filterCommonWorkOrderId) {
      alert("Please select Work Name (required)!");
      return;
    }
    if (selectedProposals.length === 0) {
      alert("Please select at least one proposal!");
      return;
    }
    if (!physicalWorkPercentage) {
      alert("Please select physical work percentage!");
      return;
    }
    if (!remarks || remarks.trim() === "") {
      alert("Please enter remarks!");
      return;
    }

    try {
      const selectedData = proposallist
        .filter((item) => selectedProposals.includes(item.WorkOrderID))
        .map((item) => ({
          ...item,
          physicalWorkPercentage,
          remarks: remarks || "",
          filterTechnicalUID: filterTechnicalUID,
          CommonWorkOrderID: filterCommonWorkOrderId,
        }));
      console.log("Selected proposals to save:", selectedData);
      setSelectedProposals([]);
      setPhysicalWorkPercentage("");
      setRemarks("");
    } catch (error) {
      console.error("Error saving proposals:", error);
      alert("Failed to save proposals!");
    }
  };

  const handlePhotoUpload = async (e, WorkName) => {
    e.preventDefault();

    // 🔐 HARD BLOCK – prevents double fire instantly
    if (submitLockRef.current) return;
    submitLockRef.current = true;

    // 🚫 UI lock
    if (loading) {
      submitLockRef.current = false;
      return;
    }

    // ===== Required field validations =====
    if (!filterHeadCode) {
      alert("Please select Head Code (required)!");
      submitLockRef.current = false;
      return;
    }
    if (!filterProposalYear) {
      alert("Please select Approval Year (required)!");
      submitLockRef.current = false;
      return;
    }
    if (workOrderType !== "Existing Work Order" && !filterTechnicalUID) {
      alert("Please select Technical Sanction Number (required)!");
      submitLockRef.current = false;
      return;
    }
    if (!filterCommonWorkOrderId) {
      alert("Please select Work Name (required)!");
      submitLockRef.current = false;
      return;
    }
    if (!physicalWorkPercentage) {
      alert("Please select physical work percentage!");
      submitLockRef.current = false;
      return;
    }
    if (!remarks || remarks.trim() === "") {
      alert("Please enter remarks!");
      submitLockRef.current = false;
      return;
    }
    if (!declarationChecked) {
      alert("Please check the declaration before proceeding!");
      submitLockRef.current = false;
      return;
    }

    setLoading(true); // 🔒 UI LOCK

    try {
      const files =
        selectedProposal && selectedProposal.WorkName === WorkName
          ? selectedImages
          : releaseFiles[WorkName];

      if (!files || files.length === 0) {
        alert("Please select photos to upload.");
        submitLockRef.current = false;
        setLoading(false);
        return;
      }

      const proposal =
        selectedProposal || proposallist.find((p) => p.WorkName === WorkName);

        console.log("Proposal found for upload:", proposal);

      if (!proposal) {
        alert("Proposal data not found!");
        submitLockRef.current = false;
        setLoading(false);
        return;
      }

      const formData = new FormData();

      files.forEach((file, index) => {
        formData.append("UploadSanctionCopy", file);
        formData.append(`ImageLocation_${index}`, "na");
      });

      formData.append("HeadCode", proposal.HeadCode);
      formData.append("WorkOrderID", proposal.WorkOrderID);
      formData.append("proposalId", proposal.ProposalID);
      formData.append("WorkName", proposal.Workorder_ProposalID || "");
      formData.append(
        "TechnicalUID",
        proposal.TechnicalUID || filterTechnicalUID,
      );
      formData.append("District", proposal.District || "");
      formData.append("Taluka", proposal.ulb || "");
      formData.append("Gram_panchayat", proposal.Gram_panchayat || "");
      formData.append("PhysicalWorkDone", physicalWorkPercentage);
      formData.append("Remark", remarks.trim());
      formData.append("ProposalYear", proposal.ProposalYear || "");
      formData.append("CommonWorkOrderID", filterCommonWorkOrderId);
      formData.append("WorkOrderType", proposal.WorkOrderType || workOrderType);

      const result = await UploadFDUTF(formData);

      if (result?.message) {
        alert("Progress Report created successfully!");

        // reset UI
        setSelectedImages([]);
        setShowPopup(false);
        setPhysicalWorkPercentage("");
        setRemarks("");
        setDeclarationChecked(false);
        setFilterTechnicalUID("");

        // ⛔ HARD LOCK remains active
        setTimeout(() => {
          window.location.reload();
        }, 300);
      } else {
        alert("Photo upload failed.");
        submitLockRef.current = false;
      }
    } catch (err) {
      console.error("Error during photo upload:", err);
      alert(`Error uploading photos: ${err.message || "Unknown error"}`);
      submitLockRef.current = false;
    } finally {
      setLoading(false);
      // ❗ DO NOT unlock here if reload is happening
    }
  };

  const handleAddClick = (proposal) => {
    // ensure required fields present before opening popup
    if (!filterHeadCode) {
      alert("Please select Head Code (required)!");
      return;
    }
    if (!filterProposalYear) {
      alert("Please select Approval Year (required)!");
      return;
    }
    if (workOrderType !== "Existing Work Order" && !filterTechnicalUID) {
      alert("Please select Technical Sanction Number (required)!");
      return;
    }
    if (!filterCommonWorkOrderId) {
      alert("Please select Work Name (required)!");
      return;
    }
    if (!physicalWorkPercentage) {
      alert("Please select physical work percentage!");
      return;
    }
    if (!remarks || remarks.trim() === "") {
      alert("Please enter remarks!");
      return;
    }
    if (!declarationChecked) {
      alert("Please check the declaration before proceeding!");
      return;
    }

    setSelectedProposal(proposal);
    setSelectedImages([]);
    setShowPopup(true);
  };

  const handleClosePopup = () => {
    setShowPopup(false);
    setSelectedProposal(null);
  };

  const selectedBillDetails = (BillID) => {
    const result = proposallist
      .filter((item) => item.ProposalID == BillID)
      .map((item) => ({
        "Work Order UID": item.WorkOrderID,
        "Head Code": item.HeadCode,
        "Proposal UID": item.ProposalID,
        "GR UID": item.GrID,
        "Proposal Year": item.ProposalYear,
        District: item.talulka,
        Taluka: item.Taluka,
        "Proposal Amount": item.Proposal_amount,
        "Work Name": item.WorkName,
        "Technical Sanction UID": item.TechnicalUID,
        "Contractor Name": item.ContractorName,
        "Work Order Number": item.WorkOrderNo,
        "Work Order Date": new Date(item.WorkOrderDate).toLocaleString(),
        "Work End Date": new Date(item.WorkEndDate).toLocaleString(),
        "Approved Work Amount": item.ApprovedWorkAmount,
        "Paid Amount": item.PaidAmount,
        "Remaining Amount": item.RemainingAmount,
        "Copy of Work Order": item.CopyofWorkOrder,
        Date: new Date(item.created_at).toLocaleString(),
      }));
    setShowDetail(result[0]);
  };

  const clearAllFilters = () => {
    setFilterHeadCode("");
    setFilterProposalYear("");
    setSearchTerm("");
    setSelectedProposals([]);
    setFilterWorkOrderId("");
    setFilterTechnicalUID("");
    setPhysicalWorkPercentage("");
    setRemarks("");
    setFilterCommonWorkOrderId("");
    setLastPhysicalValue("");
    setSelectedImages([]);
    setTechnicalInwards([]);
  };

  const getTechnicalInwardsApprove = async () => {
    let data = await GetBudgetHeadInfo(
      filterTechnicalUID,
      "GetSpecificTechincalSanctionInfoBYSanctionNo",
    );
    console.log("data", data);
    setTechnicalInwards(data[0]);
  };

  useEffect(() => {
    if (workOrderType !== "Existing Work Order" && !filterTechnicalUID) {
      setFilteredBills([]);
      setProgressPhoto([]);
      setSelectedProposals([]);
      setSelectedProposal(null);
      setSelectedImages([]);
      setPhysicalWorkPercentage("");
      setRemarks("");
      setIsDisabledSubmit(false);
      setCompletedProgress(null);
      return;
    }
    // existing behavior when a MHUID is present
    gettingProgressList();
  }, [filterTechnicalUID]);

  useEffect(() => {
    if (filterTechnicalUID !== "") {
      getTechnicalInwardsApprove();
    }
  }, [filterTechnicalUID]);

  const navigatetoMap = () => {
    // e.preventDefault();
    if (technicalInwards.MultipleGramPanchayat === "Yes") {
      const fetchurl = `https://grammanchitra.gov.in/gpassetsCollectionMH?dpcode=${technicalInwards.DPCode}&token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYmYiOjE3MTcxNDM5OTksImV4cCI6MTcxNzE1MTE5OSwiaXNzIjoiaHR0cHM6Ly9sb2NhbGhvc3Q6NzAzNC8iLCJhdWQiOiJodHRwczovL2xvY2FsaG9zdDo3MDM0LyJ9.Yb3a_9eB5DEC9OeGfO7GoUgqxnhfRDF6fZMHdPhW3hg&activityCode=${technicalInwards.Proposal_UID}&forRddAssetCode=true&projectId=${technicalInwards.Proposal_UID}&rddassetCode=${technicalInwards.GR_UID}`;
      window.open(fetchurl, "_blank");
    } else if (technicalInwards.MultipleGramPanchayat === "No") {
      const fetchurl = `https://grammanchitra.gov.in/gpassetsCollectionMH?gpcode=${technicalInwards.GPCode}&token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYmYiOjE3MTcxNDM5OTksImV4cCI6MTcxNzE1MTE5OSwiaXNzIjoiaHR0cHM6Ly9sb2NhbGhvc3Q6NzAzNC8iLCJhdWQiOiJodHRwczovL2xvY2FsaG9zdDo3MDM0LyJ9.Yb3a_9eB5DEC9OeGfO7GoUgqxnhfRDF6fZMHdPhW3hg&activityCode=${technicalInwards.Proposal_UID}&forRddAssetCode=true&projectId=${technicalInwards.Proposal_UID}&rddassetCode=${technicalInwards.GR_UID}`;
      window.open(fetchurl, "_blank");
    }
  };

  const getImageUrls = (upload) => {
    if (!upload) return [];

    try {
      const parsed = JSON.parse(upload);
      if (Array.isArray(parsed)) {
        return parsed.map((file) => `${apiurl}/uploads/${file}`);
      }
    } catch (e) {
      return [`${apiurl}/uploads/${upload}`];
    }

    return [];
  };

  return (
    <>
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(255, 255, 255, 0.7)",
            backdropFilter: "blur(4px)",
            zIndex: 9999,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              border: "6px solid #f3f3f3",
              borderTop: "6px solid #007bff",
              borderRadius: "50%",
              width: "60px",
              height: "60px",
              animation: "spin 1s linear infinite",
            }}
          />
          <style>
            {`@keyframes spin {0% { transform: rotate(0deg); }100% { transform: rotate(360deg); }}`}
          </style>
        </div>
      )}

      <div
        className="col-12"
        style={{
          backgroundColor: "#EFF3F8",
          overflowY: "scroll",
          height: "90vh",
        }}
      >
        <div className="col-12 m-auto my-5 budgetContainer">
          <div className="m-auto DemandElement">
            <form onSubmit={handleSubmitSelectedProposals}>
              <div className="row px-0 mb-0 mt-1">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    paddingLeft: "12px",
                  }}
                >
                  <img
                    src="/Progress-Report64.png"
                    alt="ProgressReport"
                    style={{ width: "32px", height: "32px" }}
                    className="my-auto me-2"
                  />
                  <h3 className="text-left fw-bold mt-2">
                    {t("Progress Report")}
                  </h3>
                </div>
                <div className="col-12 mt-4">
                  <p
                    className="py-2 ps-1 fw-bold text-danger"
                    style={{ backgroundColor: "#FBE7E7" }}
                  >
                    {t("Note : Fields marked with * are mandatory")}
                  </p>
                </div>
              </div>
              <div className="col-12 elements p-0 m-0">
                <div className="row g-0 p-0 m-0">
                  <div className="col-12 elements mb-1 p-0">
                    <div className="row g-0 p-0 m-0">
                      <div className="col-3 my-auto">
                        <label>
                          Work Order Type{" "}
                          <span style={{ color: "red" }}>*</span>
                        </label>
                      </div>

                      <div className="col-7">
                        <select
                          value={workOrderType}
                          className="py-2"
                          onChange={(e) => {
                            setWorkOrderType(e.target.value);

                            setFilterTechnicalUID("");
                            setFilterCommonWorkOrderId("");
                            setSelectedProposals([]);
                            setFilteredBills([]);
                          }}
                        >
                          <option value="" disabled>
                            Select Work Order Type
                          </option>

                          <option value="New Work Order">New Work Order</option>

                          <option value="Existing Work Order">
                            Existing Work Order
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 elements mb-1 p-0">
                    <div className="row g-0 p-0 m-0">
                      <div className="col-3 my-auto">
                        <label className="my-auto">
                          {t("Head Code")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </label>
                      </div>
                      <div className="col-7">
                        <select
                          value={filterHeadCode}
                          className="py-2"
                          onChange={(e) => {
                            setFilterHeadCode(e.target.value);
                            // setFilterProposalYear('');
                            setFilterCommonWorkOrderId("");
                            setFilterWorkOrderId("");
                            setFilterTechnicalUID("");
                          }}
                        >
                          <option value="" disabled>
                            {t("Select Head Code")}
                          </option>
                          {availableHeadCodes.map((code, i) => (
                            <option key={i} value={code.HeadID}>
                              {code.HeadName}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 elements mb-1 p-0">
                    <div className="row g-0 p-0 m-0">
                      <div className="col-3 my-auto">
                        <label>
                          {t("Approval Year")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </label>
                      </div>
                      <div className="col-7">
                        {/* <input type="text" name="ProposalYear" value={filterProposalYear} className='py-2' disabled></input> */}
                        <select
                          value={filterProposalYear}
                          className="py-2"
                          onChange={(e) => {
                            setFilterProposalYear(e.target.value);
                            setFilterWorkOrderId("");
                            setFilterCommonWorkOrderId("");
                            setFilterTechnicalUID("");
                          }}
                          disabled={!filterHeadCode}
                        >
                          <option value="" disabled>
                            {t("Select Approval Year")}
                          </option>
                          {/* {Array.from({ length: 8 }, (_, i) => {
                            const startYear = 2019 + i;
                            const endYear = startYear + 1;

                            return (
                              <option key={i} value={`${startYear}-${endYear}`}>
                                {startYear} - {endYear}
                              </option>
                            );
                          })} */}
                          {workOrderType === "Existing Work Order" ? (
                            <>
                              <option value="2019-2020">2019 - 2020</option>
                              <option value="2020-2021">2020 - 2021</option>
                              <option value="2021-2022">2021 - 2022</option>
                              <option value="2022-2023">2022 - 2023</option>
                              <option value="2023-2024">2023 - 2024</option>
                              <option value="2024-2025">2024 - 2025</option>
                              <option value="2025-2026">2025 - 2026</option>
                            </>
                          ) : workOrderType === "New Work Order" ? (
                            <>
                              <option value="2025-2026">2025 - 2026</option>
                              <option value="2026-2027">2026 - 2027</option>
                            </>
                          ) : null}
                        </select>
                      </div>
                    </div>
                  </div>

                  {/* <div className="col-12 elements mb-1 p-0">
                    <div className="row g-0 p-0 m-0">
                      <div className="col-3 my-auto">
                        <label>
                          Work Order Type{" "}
                          <span style={{ color: "red" }}>*</span>
                        </label>
                      </div>

                      <div className="col-7">
                        <select
                          value={workOrderType}
                          className="py-2"
                          onChange={(e) => {
                            setWorkOrderType(e.target.value);

                            setFilterTechnicalUID("");
                            setFilterCommonWorkOrderId("");
                            setSelectedProposals([]);
                            setFilteredBills([]);
                          }}
                        >
                          <option value="" disabled>
                            Select Work Order Type
                          </option>

                          <option value="New Work Order">New Work Order</option>

                          <option value="Existing Work Order">
                            Existing Work Order
                          </option>
                        </select>
                      </div>
                    </div>
                  </div> */}

                  {workOrderType !== "Existing Work Order" && (
                    <div className="col-12 elements mb-1 p-0">
                      <div className="row g-0 p-0 m-0">
                        <div className="col-3 my-auto">
                          <label>
                            {t("MHUID Number")}{" "}
                            <span style={{ color: "red" }}>*</span>
                          </label>
                        </div>
                        <div className="col-7">
                          <Select
                            options={
                              availableTechnicalUIDs.map((uid) => ({
                                value: uid,
                                label: uid,
                              })) || []
                            }
                            value={
                              filterTechnicalUID
                                ? {
                                    value: filterTechnicalUID,
                                    label: filterTechnicalUID,
                                  }
                                : null
                            }
                            onChange={(selectedOption) => {
                              const newTechUID = selectedOption?.value || "";

                              setFilterTechnicalUID(newTechUID);
                              setFilterCommonWorkOrderId("");
                              setSelectedProposals([]);
                              setSelectedProposal(null);
                              setSelectedImages([]);
                              setProgressPhoto([]);
                              setPhysicalWorkPercentage("");
                              setRemarks("");
                              setIsDisabledSubmit(false);
                              setCompletedProgress(null);
                              setTechnicalInwards([]);
                              setFilteredBills([]);
                              setCurrentPage(1);

                              let workid = proposallist.filter(
                                (i) =>
                                  String(i.HeadCode || "") ===
                                    String(filterHeadCode) &&
                                  String(i.ProposalYear || "") ===
                                    String(filterProposalYear) &&
                                  String(i.TechnicalUID || "") ===
                                    String(newTechUID),
                              );

                              if (workid && workid[0]) {
                                setFilterWorkOrderId(workid[0].WorkOrderID);
                                setFilterCommonWorkOrderId(workid[0].CommonWorkOrderID);
                              } else {
                                setFilterWorkOrderId("");
                              }
                            }}
                            placeholder={t("Search MHUID Number")}
                            isSearchable
                            isDisabled={!filterProposalYear}
                            className="basic-single"
                            classNamePrefix="select"
                            noOptionsMessage={() => "No MHUID Found"}
                          />
                        </div>
                      </div>
                    </div>
                  )}

                  {/* <div className="col-12 elements mb-1 p-0">
                    <div className="row g-0 p-0 m-0">
                      <div className="col-3 my-auto">
                        <label>MHUID Number</label>
                      </div>

                      <div className="col-7">
                        <input
                          name="MHUIDNo"
                          placeholder="Enter MHUID Number"
                          className="py-2"
                          value={MHUIDNo}
                          onChange={(e) => setMHUIDNo(e.target.value)}
                          maxLength={16}
                        />
                      </div>
                    </div>
                  </div> */}

                  <div className="col-12 elements mb-1 p-0">
                    <div className="row g-0 p-0 m-0">
                      <div className="col-3 my-auto">
                        <label>
                          {t("Work Name")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </label>
                      </div>
                      <div className="col-7">
                        <select
                          value={filterCommonWorkOrderId}
                          className="py-2"
                          onChange={(e) => {
                            const id = e.target.value;
                            setFilterCommonWorkOrderId(id);
                            setPhysicalWorkPercentage("");
                            console.log("Selected Completed Progress:", id);
                            // find selected row (use your full rows here)
                            const row = proposallist.find(
                              (x) => String(x.CommonWorkOrderID) === String(id),
                            );

                            const cp = row?.CompletedProgress || "";

                            setCompletedProgress(cp.replace("%", ""));
                          }}
                          disabled={!filterProposalYear || !workOrderType}
                        >
                          <option value="" disabled>
                            {t("Select Work Order ID")}
                          </option>
                          {availableCommonWorkOrderIds.map((item, i) => (
                            <option key={i} value={item.id}>
                              {item.name} (ID: {item.id})
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 mt-2">
                    <div className="row g-0 p-0 m-0">
                      <div className="col-3"></div>
                      <div className="col-7">
                        {technicalInwards && technicalInwards.Area && (
                          <button
                            className="btn btn-success px-5 py-1"
                            onClick={navigatetoMap}
                            disabled={
                              selectedProposals.length > 0 ||
                              selectedProposals.length > 0
                            }
                            style={{
                              opacity:
                                selectedProposals.length > 0 ||
                                selectedProposals.length > 0
                                  ? 0.6
                                  : 1,
                              cursor:
                                selectedProposals.length > 0 ||
                                selectedProposals.length > 0
                                  ? "not-allowed"
                                  : "pointer",
                            }}
                            title={
                              selectedProposals.length > 0 ||
                              selectedProposals.length > 0
                                ? t(
                                    "Map navigation is disabled after image upload",
                                  )
                                : t("Go To Map")
                            }
                          >
                            {t("Go To Map")}
                          </button>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="col-12 elements mb-1 p-0">
                    <div className="row g-0 p-0 m-0">
                      <div className="col-3 my-auto">
                        <label>
                          {t("Physical Work Done (%)")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </label>
                      </div>

                      <div className="col-7">
                        <select
                          value={physicalWorkPercentage}
                          onChange={(e) => {
                            const value = e.target.value;
                            const cp = completedProgress;

                            // Get existing progress values for this technical UID
                            const existingValues = progressPhoto
                              .filter(
                                (item) =>
                                  // String(item.technicalUID) ===
                                  //   String(filterTechnicalUID) &&
                                   String(item.commonWorkOrderId) ===
                                  String(filterCommonWorkOrderId) &&
                                  item.status !== "Rejected",
                              )
                              .map((item) => Number(item.physicalValue))
                              .sort((a, b) => a - b);

                            const lastProgress =
                              existingValues.length > 0
                                ? existingValues[existingValues.length - 1]
                                : 0;
                            const approvedOrPendingValues = progressPhoto
                              .filter(
                                (item) =>
                                  // String(item.technicalUID) ===
                                  //   String(filterTechnicalUID) &&
                                   String(item.commonWorkOrderId) ===
                                  String(filterCommonWorkOrderId) &&
                                  item.status !== "Rejected",
                              )
                              .map((item) => Number(item.physicalValue));

                            const alreadyExists =
                              approvedOrPendingValues.includes(Number(value));

                            // Handle CompletedProgress = 100% (disabled case)
                            if (cp === "100") {
                              alert(
                                "Work order is already completed (100%). No updates allowed.",
                              );
                              setPhysicalWorkPercentage("");
                              setIsDisabledSubmit(true);
                              return;
                            }

                            // Handle CompletedProgress = 30%
                            if (cp === "30") {
                              if (value === "30") {
                                alert(
                                  "Completed progress is already 30%. Select next (50% or 100%).",
                                );
                                setPhysicalWorkPercentage("");
                                return;
                              }

                              // Check if already uploaded
                              if (alreadyExists) {
                                alert(
                                  `Physical progress ${value}% is already recorded!`,
                                );
                                setPhysicalWorkPercentage("");
                                setIsDisabledSubmit(true);
                                return;
                              }

                              // Apply NA-like progression: if user uploaded 50, next must be 100
                              if (lastProgress === 50 && value !== "100") {
                                alert("After 50%, only 100% is allowed.");
                                setPhysicalWorkPercentage("");
                                setIsDisabledSubmit(true);
                                return;
                              }

                              // Valid selection (50 or 100)
                              setPhysicalWorkPercentage(value);
                              setIsDisabledSubmit(false);
                              return;
                            }

                            // Handle CompletedProgress = 50%
                            if (cp === "50") {
                              if (value !== "100") {
                                alert(
                                  "Completed progress is 50%. You can only select 100%.",
                                );
                                setPhysicalWorkPercentage("");
                                return;
                              }

                              // Check if already uploaded
                              if (alreadyExists) {
                                alert(
                                  `Physical progress ${value}% is already recorded!`,
                                );
                                setPhysicalWorkPercentage("");
                                setIsDisabledSubmit(true);
                                return;
                              }

                              // Valid selection (100)
                              setPhysicalWorkPercentage(value);
                              setIsDisabledSubmit(false);
                              return;
                            }

                            // For NA or empty CompletedProgress, apply normal progression rules
                            setPhysicalWorkPercentage(value);

                            if (alreadyExists) {
                              alert(
                                `Physical progress ${value}% is already recorded!`,
                              );
                              setIsDisabledSubmit(true);
                              setPhysicalWorkPercentage("");
                              return;
                            }

                            // if (lastProgress === 0 && value !== "30") {
                            //   alert("You must start with 30% progress.");
                            //   setIsDisabledSubmit(true);
                            //   setPhysicalWorkPercentage('');
                            //   return;
                            // }
                            // if (lastProgress === 30 && value !== "50") {
                            //   alert("After 30%, only 50% is allowed.");
                            //   setIsDisabledSubmit(true);
                            //   setPhysicalWorkPercentage('');
                            //   return;
                            // }
                            if (lastProgress === 50 && value !== "100") {
                              alert("After 50%, only 100% is allowed.");
                              setIsDisabledSubmit(true);
                              setPhysicalWorkPercentage("");
                              return;
                            }
                            if (lastProgress === 100) {
                              alert(
                                "Work completed (100%). No updates allowed.",
                              );
                              setIsDisabledSubmit(true);
                              setPhysicalWorkPercentage("");
                              return;
                            }

                            // Valid selection
                            setIsDisabledSubmit(false);
                          }}
                          disabled={
                            (workOrderType === "Existing Work Order"
                              ? !filterCommonWorkOrderId
                              : !filterTechnicalUID) ||
                            completedProgress === "100"
                          }
                        >
                          <option value="" disabled>
                            Select Physical Progress
                          </option>
                          <option value="30">30%</option>
                          <option value="50">50%</option>
                          <option value="100">100%</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 elements mb-1 p-0">
                    <div className="row g-0 p-0 m-0">
                      <div className="col-3 my-auto">
                        <label>
                          {t("Remark")} <span style={{ color: "red" }}>*</span>
                        </label>
                      </div>
                      <div className="col-7">
                        <textarea
                          value={remarks}
                          onChange={(e) => setRemarks(e.target.value)}
                          placeholder={t("Enter remarks here...")}
                          maxLength={100}
                          className="py-2"
                          style={{
                            width: "100%",
                            minHeight: "80px",
                            resize: "vertical",
                          }}
                          required
                          onBlur={(e) => {
                            const value = e.target.value.trim();

                            // Check if at least ONE valid character exists
                            const hasValidChar =
                              /[a-zA-Z0-9\u0900-\u097F]/.test(value);
                            if (value && !hasValidChar) {
                              setError("Enter at least one valid character");
                              alert("Enter at least one valid character");
                              setTimeout(() => e.target.focus(), 0);
                            } else {
                              setError("");
                            }
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  {((workOrderType === "Existing Work Order" &&
                    filterCommonWorkOrderId) ||
                    (workOrderType !== "Existing Work Order" &&
                      filterTechnicalUID)) && (
                    <div className="col-12 pb-5 mt-3">
                      <div
                        className="col-12 mb-3"
                        style={{
                          backgroundColor: "white",
                          padding: "30px 40px",
                          boxShadow: "0px 0px 5px 1px #E4E8EC",
                          borderRadius: "20px",
                          width: "100%",
                        }}
                      >
                        <div
                          className="col-12 tableDesign"
                          style={{
                            background: "#2C78DB",
                            display: "flex",
                            width: "70vw",
                            overflowX: "auto",
                            border: "1px solid #3b409e",
                            width: "100%",
                          }}
                        >
                          <table
                            className="m-0 p-0"
                            style={{
                              width: "100%",
                              borderCollapse: "collapse",
                            }}
                          >
                            <thead>
                              <tr
                                style={{
                                  color: "white",
                                  border: "none",
                                  height: "3rem",
                                  fontSize: "12px",
                                }}
                              >
                                <th style={headerStyle}>{t("Sr.No")}</th>
                                <th style={headerStyle}>{t("Head Code")}</th>
                                <th style={headerStyle}>{t("Work Name")}</th>
                                <th style={headerStyle}>{t("Job ID")}</th>
                                <th style={headerStyle}>{t("MHUID Number")}</th>
                                <th style={headerStyle}>
                                  {t("Financial Year")}
                                </th>
                                <th style={headerStyle}>{t("Vendor Name")}</th>
                                <th style={headerStyle}>{t("Created Date")}</th>
                                <th style={headerStyle}>{t("Upload Photo")}</th>
                              </tr>
                            </thead>
                            <tbody>
                              {currentBills?.length === 0 ? (
                                <tr>
                                  <td
                                    colSpan="8"
                                    style={{
                                      textAlign: "center",
                                      padding: "20px",
                                      backgroundColor: "#f9f9f9",
                                    }}
                                  >
                                    {t("No data available")}
                                  </td>
                                </tr>
                              ) : (
                                currentBills.map((proposal, index) => {
                                  const bgColor = selectedProposals.includes(
                                    proposal.WorkOrderID,
                                  )
                                    ? "#B3D9FF"
                                    : index % 2 === 0
                                      ? "#E5F4FB"
                                      : "#CFE4F1";
                                  return (
                                    <tr
                                      style={{
                                        backgroundColor: bgColor,
                                        fontSize: "12px",
                                        fontWeight: "500",
                                        borderBottom: "1px solid #3b409e",
                                        cursor: "pointer",
                                      }}
                                      key={index}
                                    >
                                      <td style={{ padding: "8px 8px" }}>
                                        {indexOfFirstBill + index + 1}
                                      </td>
                                      <td style={{ padding: "8px 8px" }}>
                                        {proposal.HeadCode}
                                      </td>
                                      <td style={{ padding: "8px 8px" }}>
                                        {proposal.WorkName}
                                      </td>
                                      <td style={{ padding: "8px 8px" }}>
                                        {proposal.JOB_ID}
                                      </td>
                                      <td style={{ padding: "8px 8px" }}>
                                        {proposal.TechnicalUID}
                                      </td>
                                      <td style={{ padding: "8px 8px" }}>
                                        {proposal.ProposalYear}
                                      </td>
                                      <td style={{ padding: "8px 8px" }}>
                                        {proposal.ContractorName}
                                      </td>
                                      <td
                                        style={{
                                          padding: "8px 8px",
                                          color: "#0098d5",
                                        }}
                                      >
                                        {new Date(
                                          proposal.Date,
                                        ).toLocaleString()}
                                      </td>
                                      <td style={{ padding: "8px 8px" }}>
                                        <button
                                          type="button"
                                          onClick={(e) => {
                                            e.stopPropagation();

                                            // Validate required fields before proceeding
                                            if (!filterHeadCode) {
                                              alert(
                                                t(
                                                  "Please select Head Code (required)!",
                                                ),
                                              );
                                              return;
                                            }
                                            if (!filterProposalYear) {
                                              alert(
                                                t(
                                                  "Please select Approval Year (required)!",
                                                ),
                                              );
                                              return;
                                            }
                                            if (
                                              workOrderType !==
                                                "Existing Work Order" &&
                                              !filterTechnicalUID
                                            ) {
                                              alert(
                                                t(
                                                  "Please select MHUID Number (required)!",
                                                ),
                                              );
                                              return;
                                            }
                                            if (!filterCommonWorkOrderId) {
                                              alert(
                                                t(
                                                  "Please select Work Name (required)!",
                                                ),
                                              );
                                              return;
                                            }
                                            if (!physicalWorkPercentage) {
                                              alert(
                                                t(
                                                  "Please select physical work percentage!",
                                                ),
                                              );
                                              return;
                                            }
                                            if (
                                              !remarks ||
                                              remarks.trim() === ""
                                            ) {
                                              alert(t("Please enter remarks!"));
                                              return;
                                            }
                                            if (!declarationChecked) {
                                              alert(
                                                t(
                                                  "Please check the declaration before proceeding!",
                                                ),
                                              );
                                              return;
                                            }

                                            // If disabled flag set (existing business rule), show message
                                            if (isDisabledSubmit) {
                                              alert(
                                                t(
                                                  "This physical progress already exists for the selected MH UID!",
                                                ),
                                              );
                                              return;
                                            }

                                            // All good -> select row and open popup
                                            handleRowClick(
                                              proposal.WorkOrderID,
                                            );
                                            handleAddClick(proposal);
                                          }}
                                          style={{
                                            backgroundColor: isDisabledSubmit
                                              ? "#a0a0a0"
                                              : "#2C78DB",
                                            color: "white",
                                            border: "none",
                                            borderRadius: "8px",
                                            padding: "6px 12px",
                                            fontSize: "12px",
                                            fontWeight: "500",
                                            display: "inline-flex",
                                            alignItems: "center",
                                            gap: "4px",
                                            cursor: isDisabledSubmit
                                              ? "not-allowed"
                                              : "pointer",
                                            opacity: isDisabledSubmit ? 0.7 : 1,
                                          }}
                                        >
                                          <img
                                            src="/Upload-Images64.png"
                                            alt="upload"
                                            style={{
                                              width: "14px",
                                              height: "14px",
                                              opacity: 0.8,
                                            }}
                                          />
                                          {t("Upload")}
                                        </button>
                                      </td>
                                    </tr>
                                  );
                                })
                              )}
                            </tbody>
                          </table>
                        </div>

                        {filterCommonWorkOrderId && (
                          <p
                            style={{
                              fontSize: "12px",
                              color: "red",
                              marginTop: "8px",
                            }}
                          >
                            {t(
                              "Please click on the Upload Button for uploading photos.",
                            )}
                          </p>
                        )}

                        {/* Declaration Section */}
                        <div className="mb-0 mt-5 mb-2">
                          <p
                            style={{
                              fontWeight: "600",
                              fontSize: "20px",
                              marginBottom: "4px",
                              display: "inline",
                            }}
                          >
                            {t("Declaration")}
                          </p>
                          <span style={{ color: "red", marginLeft: "4px" }}>
                            *
                          </span>
                        </div>

                        <div
                          style={{
                            display: "flex",
                            alignItems: "flex-start",
                            gap: "10px",
                            marginBottom: "8px",
                          }}
                        >
                          <div style={{ flexShrink: 0 }}>
                            <input
                              type="checkbox"
                              id="declaration"
                              checked={declarationChecked}
                              onChange={(e) =>
                                setDeclarationChecked(e.target.checked)
                              }
                              style={{
                                marginTop: "4px",
                                transform: "scale(1.2)",
                                cursor: "pointer",
                              }}
                              required
                            />
                          </div>
                          <label
                            htmlFor="declaration"
                            style={{
                              fontSize: "14px",
                              lineHeight: "1.6",
                              textAlign: "justify",
                              flex: 1,
                            }}
                          >
                            {t(
                              "I hereby declare that the information provided above and in the enclosed documents is true and correct to the best of my knowledge and belief, and nothing has been concealed. I am fully aware that if any information submitted by me is found to be false or incorrect at any stage, I will be liable for action as per the provisions of law in force, and any benefits received by me may be cancelled immediately.",
                            )}
                          </label>
                        </div>

                        <div className="mt-5" style={{ marginTop: "20px" }}>
                          <h3
                            style={{
                              fontSize: "20px",
                              fontWeight: "600",
                              marginBottom: "15px",
                            }}
                          >
                            {t("Progress Photo Uploaded")}
                          </h3>
                          <div
                            style={{
                              display: "flex",
                              gap: "16px",
                              overflowX: "auto",
                              paddingBottom: "10px",
                            }}
                          >
                            {selectedImages.length > 0 ? (
                              selectedImages.map((img, idx) => (
                                <div
                                  key={idx}
                                  style={{
                                    border: "1px solid #ddd",
                                    borderRadius: "8px",
                                    padding: "12px",
                                    textAlign: "center",
                                    boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                                    minWidth: "180px",
                                    flexShrink: 0,
                                  }}
                                >
                                  <div
                                    style={{
                                      width: "180px",
                                      height: "180px",
                                      backgroundColor: "#f3f4f6",
                                      borderRadius: "4px",
                                      overflow: "hidden",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    <img
                                      src={URL.createObjectURL(img)}
                                      alt={`preview-${idx}`}
                                      style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                      }}
                                    />
                                  </div>
                                  <div
                                    style={{
                                      marginTop: "12px",
                                      fontSize: "14px",
                                      fontWeight: "600",
                                      color: "#374151",
                                    }}
                                  >
                                    {t("Done: ")}
                                    {physicalWorkPercentage}%
                                  </div>
                                </div>
                              ))
                            ) : (
                              <p style={{ color: "#6b7280" }}>
                                {t("No progress photos available")}
                              </p>
                            )}
                          </div>
                        </div>

                        <div className="mt-5">
                          <h3
                            style={{
                              fontSize: "20px",
                              fontWeight: "600",
                              marginBottom: "15px",
                            }}
                          >
                            {t("Progress Photos Till Date")}
                          </h3>

                          <div
                            style={{
                              display: "flex",
                              gap: "16px",
                              overflowX: "auto",
                              paddingBottom: "10px",
                            }}
                          >
                            {progressPhoto.length > 0 ? (
                              progressPhoto.flatMap((photo) =>
                                getImageUrls(photo.upload).map(
                                  (imgUrl, idx) => (
                                    <div
                                      key={`${photo.id}-${idx}`}
                                      style={{
                                        border: "1px solid #ddd",
                                        borderRadius: "8px",
                                        padding: "12px",
                                        textAlign: "center",
                                        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                                        minWidth: "180px",
                                        flexShrink: 0, // 🔑 IMPORTANT for X-scroll
                                      }}
                                    >
                                      <div
                                        style={{
                                          width: "160px",
                                          height: "160px",
                                          backgroundColor: "#f3f4f6",
                                          borderRadius: "6px",
                                          overflow: "hidden",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                        }}
                                      >
                                        <img
                                          src={imgUrl}
                                          alt={`Progress-${photo.id}-${idx}`}
                                          style={{
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "cover",
                                          }}
                                          onError={(e) => {
                                            e.target.src = "/no-image.png";
                                          }}
                                        />
                                      </div>

                                      <div
                                        style={{
                                          marginTop: "10px",
                                          fontSize: "14px",
                                          fontWeight: "600",
                                          color: "#374151",
                                        }}
                                      >
                                        {t("Done: ")}
                                        {photo.physicalValue}%
                                      </div>
                                    </div>
                                  ),
                                ),
                              )
                            ) : (
                              <p style={{ color: "#6b7280" }}>
                                {t("No progress photos available")}
                              </p>
                            )}
                          </div>
                        </div>

                        <div
                          className="col-12 py-1"
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            margin: "15px 0",
                          }}
                        >
                          <p
                            className="text-gray-600"
                            style={{ fontSize: "14px", margin: 0 }}
                          >
                            {t("Showing")}{" "}
                            {filteredBills.length > 0
                              ? indexOfFirstBill + 1
                              : 0}{" "}
                            {t("to")}{" "}
                            {Math.min(indexOfLastBill, filteredBills.length)}{" "}
                            {t("of")} {filteredBills?.length} {t("entries")}
                            {selectedProposals.length > 0 &&
                              ` | Selected: ${selectedProposals.length}`}
                          </p>
                        </div>
                      </div>
                    </div>
                  )}

                  <div
                    className="col-12 mt-4"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: "15px",
                    }}
                  >
                    <div>
                      <button
                        type="button"
                        disabled={
                          isDisabledSubmit || loading || submitLockRef.current
                        }
                        onClick={(e) => {
                          if (submitLockRef.current) return;

                          if (selectedProposals.length !== 1) {
                            alert(t("Please fill in all required fields."));
                            // alert(t("Please click on the Upload Button for uploading photos"));
                            return;
                          }
                          if (!selectedImages || selectedImages.length === 0) {
                            // alert(t("Please upload photo"));
                            alert(
                              t(
                                "Please click on the Upload Button for uploading photos",
                              ),
                            );
                            return;
                          }

                          handlePhotoUpload(e, selectedProposal.WorkName);
                        }}
                        style={{
                          padding: "8px 20px",
                          backgroundColor:
                            isDisabledSubmit || loading ? "#a0a0a0" : "#007bff",
                          color: "white",
                          border: "none",
                          borderRadius: "8px",
                          fontSize: "14px",
                          cursor:
                            isDisabledSubmit || loading
                              ? "not-allowed"
                              : "pointer",
                          fontWeight: "500",
                          display: "flex",
                          alignItems: "center",
                          gap: "6px",
                          opacity: isDisabledSubmit || loading ? 0.7 : 1,
                        }}
                      >
                        {loading ? (
                          <>
                            <div
                              style={{
                                width: "16px",
                                height: "16px",
                                border: "2px solid white",
                                borderTop: "2px solid transparent",
                                borderRadius: "50%",
                                animation: "spin 0.8s linear infinite",
                              }}
                            />
                            {t("Uploading...")}
                          </>
                        ) : (
                          t("Submit")
                        )}
                      </button>
                    </div>

                    <div>
                      <button
                        type="button"
                        onClick={clearAllFilters}
                        style={{
                          padding: "8px 20px",
                          backgroundColor: "#dc3545",
                          color: "white",
                          border: "none",
                          borderRadius: "8px",
                          fontSize: "14px",
                          cursor: "pointer",
                          fontWeight: "500",
                          display: "flex",
                          alignItems: "center",
                          gap: "6px",
                        }}
                      >
                        <img
                          src="/Close-32.png"
                          alt="clear"
                          style={{ width: "14px", height: "14px" }}
                        />
                        {t("Cancel")}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>

            {showPopup && (
              <div
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: "rgba(0,0,0,0.5)",
                  backdropFilter: "blur(4px)",
                  WebkitBackdropFilter: "blur(4px)",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  zIndex: 1000,
                }}
              >
                <div
                  style={{
                    backgroundColor: "white",
                    padding: "20px",
                    borderRadius: "10px",
                    width: "500px",
                    maxWidth: "90%",
                    boxShadow: "0px 0px 10px rgba(0,0,0,0.3)",
                  }}
                >
                  <h3>{t("Upload Images for Proposal")}</h3>
                  {selectedProposal && (
                    <div style={{ marginBottom: "10px" }}>
                      <p>
                        <strong>{t("Head Code:")}</strong>{" "}
                        {selectedProposal.HeadCode}
                      </p>
                      <p>
                        <strong>{t("MHUID Number:")}</strong>{" "}
                        {selectedProposal.TechnicalUID}
                      </p>
                      <p>
                        <strong>{t("Work Name:")}</strong>{" "}
                        {selectedProposal.WorkName}
                      </p>
                    </div>
                  )}
                  {/* <input type="file" accept="image/*" multiple onChange={(e) => { const newFiles = Array.from(e.target.files); setSelectedImages(prev => [...prev, ...newFiles]); }} /> */}
                  <input
                    type="file"
                    accept="image/*"
                    multiple
                    onChange={(e) => {
                      const files = Array.from(e.target.files);

                      if (!files.length) return;

                      const allowedTypes = [
                        "image/jpeg",
                        "image/png",
                        "image/jpg",
                      ];

                      // Check if any file is invalid
                      const invalidFiles = files.filter(
                        (file) => !allowedTypes.includes(file.type),
                      );

                      if (invalidFiles.length > 0) {
                        alert("Only JPG, JPEG, PNG files are allowed");
                        e.target.value = ""; // reset input
                        return;
                      }

                      // If all files are valid → add to state
                      setSelectedImages((prev) => [...prev, ...files]);
                    }}
                  />

                  {selectedImages.length > 0 && (
                    <div
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        marginTop: "10px",
                        gap: "10px",
                      }}
                    >
                      {selectedImages.map((img, idx) => (
                        <div key={idx} style={{ position: "relative" }}>
                          <img
                            src={URL.createObjectURL(img)}
                            alt={`preview-${idx}`}
                            style={{
                              width: "100px",
                              height: "100px",
                              objectFit: "cover",
                              borderRadius: "5px",
                              border: "1px solid #ccc",
                            }}
                          />
                          <button
                            onClick={() => {
                              setSelectedImages((prev) =>
                                prev.filter((_, i) => i !== idx),
                              );
                            }}
                            style={{
                              position: "absolute",
                              top: 0,
                              right: 0,
                              background: "red",
                              color: "white",
                              border: "none",
                              borderRadius: "0 0 0 5px",
                              cursor: "pointer",
                              fontSize: "12px",
                              padding: "2px 4px",
                            }}
                          >
                            X
                          </button>
                        </div>
                      ))}
                    </div>
                  )}

                  <div
                    style={{
                      marginTop: "15px",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <button
                      style={{
                        marginTop: "5px",
                        padding: "5px 10px",
                        backgroundColor: "red",
                        color: "white",
                        borderRadius: "6px",
                        border: "none",
                      }}
                      onClick={() => setShowPopup(false)}
                    >
                      {t("Close")}
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {showDetail && (
        <div
          onClick={() => setShowDetail(null)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0, 0, 0, 0.84)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              backgroundColor: "white",
              padding: "40px 40px",
              borderRadius: "20px",
              width: "50%",
              maxHeight: "90vh",
              overflow: "hidden",
              boxShadow: "0 2px 10px rgba(0,0,0,0.3)",
              position: "relative",
            }}
          >
            <div className="col-12">
              <div className="col-12 mb-3">
                <div className="row">
                  <div className="col-6">
                    <h5 className="fw-bold">{t("Proposal Details")}</h5>
                  </div>
                  <div
                    className="col-6"
                    style={{ display: "flex", justifyContent: "flex-end" }}
                  >
                    <button
                      onClick={() => setShowDetail(null)}
                      style={{
                        width: "32px",
                        height: "32px",
                        borderRadius: "50%",
                        backgroundColor: "red",
                        border: "none",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        cursor: "pointer",
                        fontSize: "24px",
                        fontWeight: "bold",
                        color: "white",
                        lineHeight: 1,
                      }}
                    >
                      ×
                    </button>
                  </div>
                </div>
              </div>
              <div
                className="col-12"
                style={{
                  height: "59vh",
                  overflowX: "hidden",
                  overflowY: "scroll",
                  scrollBehavior: "smooth",
                }}
              >
                <table
                  style={{
                    width: "100%",
                    height: "100%",
                    borderCollapse: "collapse",
                  }}
                >
                  <tbody>
                    {Object.entries(showDetail).map(([key, value], index) => (
                      <tr
                        key={key}
                        style={{
                          backgroundColor:
                            index % 2 === 0 ? "#2B75D5" : "#cce0f9",
                          border: "1px solid #cce0f9",
                        }}
                      >
                        <td
                          style={{
                            fontWeight: "bold",
                            padding: "8px 8px",
                            width: "40%",
                            backgroundColor: "#2B75D5",
                            color: "white",
                            border: "1px solid #cce0f9",
                          }}
                        >
                          {key}
                        </td>
                        <td
                          style={{
                            padding: "8px 8px",
                            color: "black",
                            backgroundColor:
                              index % 2 === 0 ? "#E3EBF5" : "#D0DEF1",
                          }}
                        >
                          {key === "Copy of Work Order" && value ? (
                            <a
                              href={`${apiurl}/uploads/${value}`}
                              target="_blank"
                              rel="noreferrer"
                            >
                              {value}
                            </a>
                          ) : value === null || value === "" ? (
                            "-"
                          ) : (
                            value.toString()
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ProgressReport;

// import React, { useContext, useEffect, useState } from 'react';
// import AdminContext from '../../StateContext/Application';
// import { apiurl } from '../../../../path';
// import "./rejectpanel.css"
// import { useLanguage } from '../../../../lang/langcontext/LanguageContext';

// const ProgressReport = () => {
//   const { language, toggleLanguage, t } = useLanguage();
//   const context = useContext(AdminContext);
//   const { GetAllWorkOrderList, UploadFDUTF, GetPrograsslist, GetBudgetHeadInfo, GetTechnicalInwardsList } = context;
//   const [showPopup, setShowPopup] = useState(false);
//   const [showDetail, setShowDetail] = useState(false);
//   const [selectedProposal, setSelectedProposal] = useState(null);
//   const [proposallist, setProposalList] = useState([]);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [filteredBills, setFilteredBills] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const billsPerPage = 10;
//   const [releaseFiles, setReleaseFiles] = useState({});
//   const [selectedImages, setSelectedImages] = useState([]);
//   const [progressPhoto, setProgressPhoto] = useState([])
//   // Filter states
//   const [filterHeadCode, setFilterHeadCode] = useState('');
//   const [filterProposalYear, setFilterProposalYear] = useState('');
//   const [selectedProposals, setSelectedProposals] = useState([]);
//   const [filterWorkOrderId, setFilterWorkOrderId] = useState('');
//   const [physicalWorkPercentage, setPhysicalWorkPercentage] = useState('');
//   const [remarks, setRemarks] = useState('');
//   const [filterTechnicalUID, setFilterTechnicalUID] = useState('');
//   const [filterCommonWorkOrderId, setFilterCommonWorkOrderId] = useState('');
//   const [declarationChecked, setDeclarationChecked] = useState(false);
//   const [lastPhysicalValue, setLastPhysicalValue] = useState(0);
//   const [availableHeadCodes, setavailableHeadCodes] = useState([]);
//   const [technicalInwards, setTechnicalInwards] = useState([]);
//   const [isDisabledSubmit, setIsDisabledSubmit] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [completedProgress, setCompletedProgress] = useState(null);

//   console.log("progress photo: ", progressPhoto);

//   const headerStyle = {
//     padding: "9px 12px",
//     whiteSpace: "nowrap",
//     borderRight: "1px solid #e0e0e0",
//     textTransform: "capitalize",
//   };

//   const proposalEstimate = async () => {
//     let data = await GetAllWorkOrderList();
//     console.log("proposal data", data);
//     setProposalList(data);
//   };

//   const gettingProgressList = async () => {
//     let previousPhoto = await GetPrograsslist();

//     const filteredPhotos = previousPhoto.filter(
//       item => item.TechnicalUID === filterTechnicalUID
//     );

//     console.log("check physical", previousPhoto);

//     const photoData = filteredPhotos.map(item => ({
//       id: item.ID,
//       uploadID: item.UploadID,
//       upload: item.Upload,
//       physicalValue: item.physicalValue,
//       technicalUID: item.TechnicalUID,
//       headCode: item.Head_Code,
//       workOrderNo: item.WorkOrderNo,
//       status: item.Status
//     }));
//     setProgressPhoto(photoData);

//     const lastEntry = filteredPhotos.at(-1);
//     setLastPhysicalValue(lastEntry ? Number(lastEntry.physicalValue) : 0);
//   };

//   const FetchHeadInfo = async () => {
//     try {
//       let res = await GetBudgetHeadInfo("null", "all");
//       console.log("Data i get from Bakcend :: ", res);
//       setavailableHeadCodes(res);
//     }
//     catch (err) {
//       console.log(err);
//     }
//   }

//   useEffect(() => {
//     proposalEstimate();
//     FetchHeadInfo();
//   }, []);

//   useEffect(() => {
//     console.log("Filter values:", {
//       filterHeadCode,
//       filterProposalYear,
//       filterCommonWorkOrderId,
//       filterWorkOrderId,
//       filterTechnicalUID
//     });
//     console.log("Filtered bills:", filteredBills);
//     // ... rest of your code
//   }, [proposallist, filterHeadCode, filterProposalYear, filterCommonWorkOrderId, filterWorkOrderId, searchTerm, filterTechnicalUID]);

//   useEffect(() => {
//     if (filterTechnicalUID) {
//       gettingProgressList();
//     }
//   }, [filterTechnicalUID]);

//   useEffect(() => {
//     let filtered = [...proposallist];

//     const dataAfterHeadCode = filterHeadCode
//       ? proposallist.filter(item => String(item.HeadCode) === String(filterHeadCode))
//       : proposallist;

//     const dataAfterYear = filterProposalYear
//       ? dataAfterHeadCode.filter(item => String(item.ProposalYear) === String(filterProposalYear))
//       : dataAfterHeadCode;

//     const dataAfterCommonWorkOrder = filterCommonWorkOrderId
//       ? dataAfterYear.filter(item => String(item.CommonWorkOrderID) === String(filterCommonWorkOrderId))
//       : dataAfterYear;

//     const dataAfterWorkOrder = filterWorkOrderId
//       ? dataAfterCommonWorkOrder.filter(item => String(item.WorkOrderID) === String(filterWorkOrderId))
//       : dataAfterCommonWorkOrder;

//     if (filterTechnicalUID && filterTechnicalUID !== '') {
//       filtered = dataAfterWorkOrder.filter(item => String(item.TechnicalUID) === String(filterTechnicalUID));
//     } else {
//       filtered = dataAfterWorkOrder;
//     }

//     if (searchTerm) {
//       const lowerSearchTerm = searchTerm.toLowerCase();
//       filtered = filtered.filter(bill =>
//         Object.values(bill).some((val) =>
//           (val || '').toString().toLowerCase().includes(lowerSearchTerm)
//         )
//       );
//     }

//     setFilteredBills(filtered);
//     setSelectedProposals([]);
//   }, [proposallist, filterHeadCode, filterProposalYear, filterCommonWorkOrderId, filterWorkOrderId, searchTerm, filterTechnicalUID]);

//   useEffect(() => {
//     setCurrentPage(1);
//   }, [filterHeadCode, filterCommonWorkOrderId, filterProposalYear, searchTerm]);

//   useEffect(() => {
//     if (selectedProposals.length === 1) {
//       const proposal = proposallist.find(p => p.WorkOrderID === selectedProposals[0]);
//       setSelectedProposal(proposal);
//     } else {
//       setSelectedProposal(null);
//     }

//   }, [selectedProposals]);

//   // const availableHeadCodes = [...new Set(proposallist.map(item => item.HeadCode))].filter(Boolean);

//   const availableProposalYears = filterHeadCode
//     ? [...new Set(
//       proposallist
//         .filter(i => i.HeadCode === filterHeadCode)
//         .map(i => i.ProposalYear)
//     )].filter(Boolean)
//     : [];

//   const availableCommonWorkOrderIds = filterTechnicalUID
//     ? proposallist
//       .filter(i =>
//         i.HeadCode === filterHeadCode &&
//         i.ProposalYear === filterProposalYear &&
//         i.TechnicalUID === filterTechnicalUID
//       )
//       .reduce((acc, i) => {

//         if (i.CommonWorkOrderID && !acc.find(item => item.id === i.CommonWorkOrderID)) {
//           acc.push({
//             id: i.CommonWorkOrderID,
//             name: i.WorkName
//           });
//         }
//         return acc;
//       }, [])
//     : [];

//   const availableWorkOrderIds = filterCommonWorkOrderId
//     ? proposallist
//       .filter(i => String(i.CommonWorkOrderID || '') === String(filterCommonWorkOrderId))
//       .reduce((acc, i) => {
//         // avoid duplicates
//         if (!acc.find(item => item.id === i.WorkOrderID)) {
//           acc.push({
//             id: i.WorkOrderID,
//             name: i.Workorder_ProposalID
//           });
//         }
//         return acc;
//       }, [])
//     : [];

//   const availableTechnicalUIDs = filterProposalYear
//     ? [...new Set(
//       proposallist
//         .filter(i =>
//           String(i.HeadCode || '') === String(filterHeadCode) &&
//           String(i.ProposalYear || '') === String(filterProposalYear)
//           // String(i.CommonWorkOrderID || '') === String(filterCommonWorkOrderId)
//           // String(i.WorkOrderID || '') === String(filterWorkOrderId)
//         )
//         .map(i => i.TechnicalUID)
//     )].filter(Boolean)
//     : [];

//   const totalPages = Math.ceil(filteredBills.length / billsPerPage);
//   const indexOfLastBill = currentPage * billsPerPage;
//   const indexOfFirstBill = indexOfLastBill - billsPerPage;
//   const currentBills = filteredBills?.slice(indexOfFirstBill, indexOfLastBill);

//   // Updated: Auto-select row when clicked
//   const handleRowClick = (workOrderID) => {
//     setSelectedProposals([workOrderID]);
//   };

//   const handleSubmitSelectedProposals = async (e) => {
//     e.preventDefault();

//     // Mandatory field checks
//     if (!filterHeadCode) {
//       alert("Please select Head Code (required)!");
//       return;
//     }
//     if (!filterProposalYear) {
//       alert("Please select Approval Year (required)!");
//       return;
//     }
//     if (!filterTechnicalUID) {
//       alert("Please select MHUID Number (required)!");
//       return;
//     }
//     if (!filterCommonWorkOrderId) {
//       alert("Please select Work Order Name (required)!");
//       return;
//     }
//     if (selectedProposals.length === 0) {
//       alert("Please select at least one proposal!");
//       return;
//     }
//     if (!physicalWorkPercentage) {
//       alert("Please select physical work percentage!");
//       return;
//     }
//     if (!remarks || remarks.trim() === '') {
//       alert("Please enter remarks!");
//       return;
//     }

//     try {
//       const selectedData = proposallist.filter(item =>
//         selectedProposals.includes(item.WorkOrderID)
//       ).map(item => ({
//         ...item,
//         physicalWorkPercentage,
//         remarks: remarks || '',
//         filterTechnicalUID: filterTechnicalUID,
//         CommonWorkOrderID: filterCommonWorkOrderId
//       }));
//       console.log("Selected proposals to save:", selectedData);
//       setSelectedProposals([]);
//       setPhysicalWorkPercentage('');
//       setRemarks('');
//     } catch (error) {
//       console.error("Error saving proposals:", error);
//       alert("Failed to save proposals!");
//     }
//   };

//   const handlePhotoUpload = async (e, WorkName) => {
//     e.preventDefault();
//     if (loading) return;

//     // Required field checks before doing anything
//     if (!filterHeadCode) {
//       alert("Please select Head Code (required)!");
//       return;
//     }
//     if (!filterProposalYear) {
//       alert("Please select Approval Year (required)!");
//       return;
//     }
//     if (!filterTechnicalUID) {
//       alert("Please select MHUID Number (required)!");
//       return;
//     }
//     if (!filterCommonWorkOrderId) {
//       alert("Please select Work Order Name (required)!");
//       return;
//     }
//     if (!physicalWorkPercentage) {
//       alert("Please select physical work percentage!");
//       return;
//     }
//     if (!remarks || remarks.trim() === '') {
//       alert("Please enter remarks!");
//       return;
//     }
//     if (!declarationChecked) {
//       alert("Please check the declaration before proceeding!");
//       return;
//     }

//     setLoading(true);

//     try {
//       const files = selectedProposal && selectedProposal.WorkName === WorkName
//         ? selectedImages
//         : releaseFiles[WorkName];

//       if (!files || files.length === 0) {
//         alert("Please select photos to upload.");
//         setLoading(false);
//         return;
//       }

//       const proposal = selectedProposal || proposallist.find(p => p.WorkName === WorkName);
//       if (!proposal) {
//         alert("Proposal data not found!");
//         setLoading(false);
//         return;
//       }

//       const formData = new FormData();
//       files.forEach((file, index) => {
//         formData.append("UploadSanctionCopy", file);
//         formData.append(`ImageLocation_${index}`, 'na');
//       });

//       formData.append("HeadCode", proposal.HeadCode);
//       formData.append("WorkOrderID", proposal.WorkOrderID);
//       formData.append("proposalId", proposal.ProposalID);
//       formData.append("WorkName", proposal.Workorder_ProposalID || '');
//       formData.append("TechnicalUID", proposal.TechnicalUID || filterTechnicalUID || '');
//       formData.append("District", proposal.District || '');
//       formData.append("Taluka", proposal.Taluka || '');
//       formData.append("Gram_panchayat", proposal.Gram_panchayat || '');
//       formData.append("PhysicalWorkDone", physicalWorkPercentage || '0%');
//       formData.append("Remark", remarks || '');
//       formData.append("ProposalYear", proposal.ProposalYear || '');
//       formData.append("CommonWorkOrderID", filterCommonWorkOrderId || '');
//       const result = await UploadFDUTF(formData);
//       if (result?.message) {
//         alert("Progress Report created successfully!");
//         setSelectedImages([]);
//         setShowPopup(false);
//         setPhysicalWorkPercentage('');
//         setRemarks('');
//         setDeclarationChecked(false)
//         setFilterTechnicalUID('');
//         proposalEstimate();
//         window.location.reload();
//       } else {
//         alert("Photo upload failed.");
//       }
//     } catch (err) {
//       console.error("Error during photo upload:", err);
//       alert(`Error uploading photos: ${err.message || 'Unknown error'}`);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleAddClick = (proposal) => {
//     // ensure required fields present before opening popup
//     if (!filterHeadCode) {
//       alert("Please select Head Code (required)!");
//       return;
//     }
//     if (!filterProposalYear) {
//       alert("Please select Approval Year (required)!");
//       return;
//     }
//     if (!filterTechnicalUID) {
//       alert("Please select MHUID Number (required)!");
//       return;
//     }
//     if (!filterCommonWorkOrderId) {
//       alert("Please select Work Order Name (required)!");
//       return;
//     }
//     if (!physicalWorkPercentage) {
//       alert("Please select physical work percentage!");
//       return;
//     }
//     if (!remarks || remarks.trim() === '') {
//       alert("Please enter remarks!");
//       return;
//     }
//     if (!declarationChecked) {
//       alert("Please check the declaration before proceeding!");
//       return;
//     }

//     setSelectedProposal(proposal);
//     setSelectedImages([]);
//     setShowPopup(true);
//   };

//   const handleClosePopup = () => {
//     setShowPopup(false);
//     setSelectedProposal(null);
//   };

//   const selectedBillDetails = (BillID) => {
//     const result = proposallist
//       .filter(item => item.ProposalID == BillID)
//       .map(item => ({
//         "Work Order UID": item.WorkOrderID,
//         "Head Code": item.HeadCode,
//         "Proposal UID": item.ProposalID,
//         "GR UID": item.GrID,
//         "Proposal Year": item.ProposalYear,
//         "District": item.talulka,
//         "Taluka": item.Taluka,
//         "Proposal Amount": item.Proposal_amount,
//         "Work Name": item.WorkName,
//         "Technical Sanction UID": item.TechnicalUID,
//         "Contractor Name": item.ContractorName,
//         "Work Order Number": item.WorkOrderNo,
//         "Work Order Date": new Date(item.WorkOrderDate).toLocaleString(),
//         "Work End Date": new Date(item.WorkEndDate).toLocaleString(),
//         "Approved Work Amount": item.ApprovedWorkAmount,
//         "Paid Amount": item.PaidAmount,
//         "Remaining Amount": item.RemainingAmount,
//         "Copy of Work Order": item.CopyofWorkOrder,
//         "Date": new Date(item.created_at).toLocaleString(),
//       }));
//     setShowDetail(result[0]);
//   };

//   const clearAllFilters = () => {
//     setFilterHeadCode('');
//     setFilterProposalYear('');
//     setSearchTerm('');
//     setSelectedProposals([]);
//     setFilterWorkOrderId('');
//     setFilterTechnicalUID('');
//     setPhysicalWorkPercentage('');
//     setRemarks('');
//     setFilterCommonWorkOrderId('');
//     setLastPhysicalValue('');
//     setSelectedImages([]);
//     setTechnicalInwards([]);
//   };

//   const getTechnicalInwardsApprove = async () => {
//     let data = await GetBudgetHeadInfo(filterTechnicalUID, "GetSpecificTechincalSanctionInfoBYSanctionNo")
//     console.log("data", data);
//     setTechnicalInwards(data[0]);
//   };

//   useEffect(() => {
//     if (!filterTechnicalUID) {
//       setFilteredBills([]);
//       setProgressPhoto([]);
//       setSelectedProposals([]);
//       setSelectedProposal(null);
//       setSelectedImages([]);
//       setPhysicalWorkPercentage('');
//       setRemarks('');
//       setIsDisabledSubmit(false);
//       setCompletedProgress(null);
//       return;
//     }
//     // existing behavior when a MHUID is present
//     gettingProgressList();
//   }, [filterTechnicalUID]);

//   useEffect(() => {
//     if (filterTechnicalUID !== "") {
//       getTechnicalInwardsApprove();
//     }
//   }, [filterTechnicalUID]);

//   const navigatetoMap = () => {
//     // e.preventDefault();
//     if (technicalInwards.MultipleGramPanchayat === "Yes") {
//       const fetchurl = `https://grammanchitra.gov.in/gpassetsCollectionMH?dpcode=${technicalInwards.DPCode}&token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYmYiOjE3MTcxNDM5OTksImV4cCI6MTcxNzE1MTE5OSwiaXNzIjoiaHR0cHM6Ly9sb2NhbGhvc3Q6NzAzNC8iLCJhdWQiOiJodHRwczovL2xvY2FsaG9zdDo3MDM0LyJ9.Yb3a_9eB5DEC9OeGfO7GoUgqxnhfRDF6fZMHdPhW3hg&activityCode=${technicalInwards.Proposal_UID}&forRddAssetCode=true&projectId=${technicalInwards.Proposal_UID}&rddassetCode=${technicalInwards.GR_UID}`;
//       window.open(fetchurl, "_blank");
//     }

//     else if (technicalInwards.MultipleGramPanchayat === "No") {
//       const fetchurl = `https://grammanchitra.gov.in/gpassetsCollectionMH?gpcode=${technicalInwards.GPCode}&token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYmYiOjE3MTcxNDM5OTksImV4cCI6MTcxNzE1MTE5OSwiaXNzIjoiaHR0cHM6Ly9sb2NhbGhvc3Q6NzAzNC8iLCJhdWQiOiJodHRwczovL2xvY2FsaG9zdDo3MDM0LyJ9.Yb3a_9eB5DEC9OeGfO7GoUgqxnhfRDF6fZMHdPhW3hg&activityCode=${technicalInwards.Proposal_UID}&forRddAssetCode=true&projectId=${technicalInwards.Proposal_UID}&rddassetCode=${technicalInwards.GR_UID}`;
//       window.open(fetchurl, "_blank");
//     }

//   };

//   const getImageUrls = (upload) => {
//     if (!upload) return [];

//     try {
//       const parsed = JSON.parse(upload);
//       if (Array.isArray(parsed)) {
//         return parsed.map(file => `${apiurl}/uploads/${file}`);
//       }
//     } catch (e) {
//       return [`${apiurl}/uploads/${upload}`];
//     }

//     return [];
//   };

//   return (
//     <>

//       {loading && (
//         <div
//           style={{
//             position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(255, 255, 255, 0.7)', backdropFilter: 'blur(4px)', zIndex: 9999,
//             display: 'flex', justifyContent: 'center', alignItems: 'center'
//           }}>
//           <div style={{ border: '6px solid #f3f3f3', borderTop: '6px solid #007bff', borderRadius: '50%', width: '60px', height: '60px', animation: 'spin 1s linear infinite' }} />
//           <style>
//             {`@keyframes spin {0% { transform: rotate(0deg); }100% { transform: rotate(360deg); }}`}
//           </style>
//         </div>
//       )}

//       <div className="col-12" style={{ backgroundColor: "#EFF3F8", overflowY: 'scroll', height: '90vh' }}>

//         <div className="col-12 m-auto my-5 budgetContainer">

//           <div className="m-auto DemandElement">

//             <form onSubmit={handleSubmitSelectedProposals}>
//               <div className="row px-0 mb-0 mt-1">
//                 <div style={{ display: "flex", alignItems: "center", paddingLeft: "12px" }}>
//                   <img src="/Progress-Report64.png" alt="ProgressReport" style={{ width: "32px", height: "32px" }} className='my-auto me-2' />
//                   <h3 className='text-left fw-bold mt-2'>{t("Progress Report")}</h3>
//                 </div>
//                 <div className="col-12 mt-4">
//                   <p className='py-2 ps-1 fw-bold text-danger' style={{ backgroundColor: "#FBE7E7" }}>{t("Note : Fields marked with * are mandatory")}</p>
//                 </div>
//               </div>
//               <div className="col-12 elements p-0 m-0">
//                 <div className="row g-0 p-0 m-0">
//                   <div className="col-12 elements mb-1 p-0">
//                     <div className="row g-0 p-0 m-0">
//                       <div className="col-3 my-auto">

//                         <label className='my-auto'>{t("Head Code")} <span style={{ color: 'red' }}>*</span></label>
//                       </div>
//                       <div className="col-7">
//                         <select
//                           value={filterHeadCode}
//                           className='py-2'
//                           onChange={(e) => {
//                             setFilterHeadCode(e.target.value);
//                             setFilterProposalYear('');
//                             setFilterCommonWorkOrderId('');
//                             setFilterWorkOrderId('');
//                             setFilterTechnicalUID('');
//                           }}
//                         >
//                           <option value="" disabled>{t("Select Head Code")}</option>
//                           {availableHeadCodes.map((code, i) => (
//                             <option key={i} value={code.HeadID}>{code.HeadName}</option>
//                           ))}
//                         </select>
//                       </div>
//                     </div>
//                   </div>

//                   <div className="col-12 elements mb-1 p-0">
//                     <div className="row g-0 p-0 m-0">
//                       <div className="col-3 my-auto">

//                         <label>{t("Approval Year")} <span style={{ color: 'red' }}>*</span></label>
//                       </div>
//                       <div className="col-7">
//                         <select
//                           value={filterProposalYear}
//                           className='py-2'
//                           onChange={(e) => {
//                             setFilterProposalYear(e.target.value);
//                             setFilterWorkOrderId('');
//                             setFilterCommonWorkOrderId('');
//                             setFilterTechnicalUID('');
//                           }}
//                           disabled={!filterHeadCode}
//                         >
//                           <option value="" disabled>{t("Select Approval Year")}</option>
//                           {/* {availableProposalYears.map((yr, i) => (
//                             <option key={i} value={yr}>{yr}</option>
//                           ))} */}
//                           <option value="2024-2025">2024 - 2025</option>
//                           <option value="2025-2026">2025 - 2026</option>
//                         </select>
//                       </div>
//                     </div>
//                   </div>

//                   <div className="col-12 elements mb-1 p-0">
//                     <div className="row g-0 p-0 m-0">
//                       <div className="col-3 my-auto">

//                         <label>{t("MHUID Number")} <span style={{ color: 'red' }}>*</span></label>
//                       </div>
//                       <div className="col-7">
//                         <select
//                           value={filterTechnicalUID}
//                           className='py-2'
//                           onChange={(e) => {
//                             const newTechUID = e.target.value;

//                             // reset dependent filters/selections and table when MHUID changes
//                             setFilterTechnicalUID(newTechUID);
//                             setFilterCommonWorkOrderId('');
//                             setSelectedProposals([]);
//                             setSelectedProposal(null);
//                             setSelectedImages([]);
//                             setProgressPhoto([]);        // reset existing progress photo listing for previous MHUID
//                             setPhysicalWorkPercentage('');
//                             setRemarks('');
//                             setIsDisabledSubmit(false);
//                             setCompletedProgress(null);
//                             setTechnicalInwards([]);
//                             setFilteredBills([]);       // clear table results
//                             setCurrentPage(1);

//                             // keep prior behavior to pre-select a WorkOrderID if available
//                             let workid = proposallist.filter(
//                               (i) =>
//                                 String(i.HeadCode || '') === String(filterHeadCode) &&
//                                 String(i.ProposalYear || '') === String(filterProposalYear) &&
//                                 String(i.TechnicalUID || '') === String(newTechUID)
//                             );

//                             if (workid && workid[0]) {
//                               setFilterWorkOrderId(workid[0].WorkOrderID);
//                             } else {
//                               setFilterWorkOrderId('');
//                             }
//                           }}
//                           disabled={!filterProposalYear}
//                         >
//                           <option value="" disabled>{t("Select MHUID Number")}</option>
//                           {availableTechnicalUIDs.map((uid, i) => (
//                             <option key={i} value={uid}>{uid}</option>
//                           ))}
//                         </select>
//                       </div>
//                     </div>
//                   </div>

//                   <div className="col-12 elements mb-1 p-0">
//                     <div className="row g-0 p-0 m-0">
//                       <div className="col-3 my-auto">

//                         <label>{t("Work Order Name")} <span style={{ color: 'red' }}>*</span></label>
//                       </div>
//                       <div className="col-7">
//                         <select
//                           value={filterCommonWorkOrderId}
//                           className='py-2'
//                           onChange={(e) => {
//                             const id = e.target.value;
//                             setFilterCommonWorkOrderId(id);
//                             setPhysicalWorkPercentage("");
//                             console.log("Selected Completed Progress:", id);
//                             // find selected row (use your full rows here)
//                             const row = proposallist.find(x => String(x.CommonWorkOrderID) === String(id));

//                             const cp = row?.CompletedProgress || "";

//                             setCompletedProgress(cp.replace("%", ""));
//                           }}

//                           disabled={!filterProposalYear}
//                         >
//                           <option value="" disabled>{t("Select Work Order ID")}</option>
//                           {availableCommonWorkOrderIds.map((item, i) => (
//                             <option key={i} value={item.id}>
//                               {item.name} (ID: {item.id})
//                             </option>
//                           ))}
//                         </select>
//                       </div>
//                     </div>

//                   </div>

//                   <div className="col-12 mt-2">
//                     <div className="row g-0 p-0 m-0">
//                       <div className="col-3"></div>
//                       <div className="col-7">
//                         {
//                           technicalInwards &&
//                           technicalInwards.Area && (
//                             <button
//                               className='btn btn-success px-5 py-1'
//                               onClick={navigatetoMap}
//                               disabled={selectedProposals.length > 0 || selectedProposals.length > 0}
//                               style={{
//                                 opacity: (selectedProposals.length > 0 || selectedProposals.length > 0) ? 0.6 : 1,
//                                 cursor: (selectedProposals.length > 0 || selectedProposals.length > 0)
//                                   ? "not-allowed"
//                                   : "pointer"
//                               }}
//                               title={
//                                 selectedProposals.length > 0 || selectedProposals.length > 0
//                                   ? t("Map navigation is disabled after image upload")
//                                   : t("Go To Map")
//                               }
//                             >
//                               {t("Go To Map")}
//                             </button>
//                           )
//                         }
//                       </div>
//                     </div>
//                   </div>

//                   <div className="col-12 elements mb-1 p-0">
//                     <div className="row g-0 p-0 m-0">
//                       <div className="col-3 my-auto">
//                         <label>
//                           {t("Physical Work Done (%)")} <span style={{ color: 'red' }}>*</span>
//                         </label>
//                       </div>

//                       <div className="col-7">
//                         <select
//                           value={physicalWorkPercentage}
//                           onChange={(e) => {
//                             const value = e.target.value;
//                             const cp = completedProgress;

//                             // Get existing progress values for this technical UID
//                             const existingValues = progressPhoto
//                               .filter(item => String(item.technicalUID) === String(filterTechnicalUID) &&
//                                 item.status !== "Rejected")
//                               .map(item => Number(item.physicalValue))
//                               .sort((a, b) => a - b);

//                             const lastProgress = existingValues.length > 0 ? existingValues[existingValues.length - 1] : 0;
//                             const approvedOrPendingValues = progressPhoto
//                               .filter(item =>
//                                 String(item.technicalUID) === String(filterTechnicalUID) &&
//                                 item.status !== "Rejected"
//                               )
//                               .map(item => Number(item.physicalValue));

//                             const alreadyExists = approvedOrPendingValues.includes(Number(value));

//                             // Handle CompletedProgress = 100% (disabled case)
//                             if (cp === "100") {
//                               alert("Work order is already completed (100%). No updates allowed.");
//                               setPhysicalWorkPercentage("");
//                               setIsDisabledSubmit(true);
//                               return;
//                             }

//                             // Handle CompletedProgress = 30%
//                             if (cp === "30") {
//                               if (value === "30") {
//                                 alert("Completed progress is already 30%. Select next (50% or 100%).");
//                                 setPhysicalWorkPercentage("");
//                                 return;
//                               }

//                               // Check if already uploaded
//                               if (alreadyExists) {
//                                 alert(`Physical progress ${value}% is already recorded!`);
//                                 setPhysicalWorkPercentage("");
//                                 setIsDisabledSubmit(true);
//                                 return;
//                               }

//                               // Apply NA-like progression: if user uploaded 50, next must be 100
//                               if (lastProgress === 50 && value !== "100") {
//                                 alert("After 50%, only 100% is allowed.");
//                                 setPhysicalWorkPercentage("");
//                                 setIsDisabledSubmit(true);
//                                 return;
//                               }

//                               // Valid selection (50 or 100)
//                               setPhysicalWorkPercentage(value);
//                               setIsDisabledSubmit(false);
//                               return;
//                             }

//                             // Handle CompletedProgress = 50%
//                             if (cp === "50") {
//                               if (value !== "100") {
//                                 alert("Completed progress is 50%. You can only select 100%.");
//                                 setPhysicalWorkPercentage("");
//                                 return;
//                               }

//                               // Check if already uploaded
//                               if (alreadyExists) {
//                                 alert(`Physical progress ${value}% is already recorded!`);
//                                 setPhysicalWorkPercentage("");
//                                 setIsDisabledSubmit(true);
//                                 return;
//                               }

//                               // Valid selection (100)
//                               setPhysicalWorkPercentage(value);
//                               setIsDisabledSubmit(false);
//                               return;
//                             }

//                             // For NA or empty CompletedProgress, apply normal progression rules
//                             setPhysicalWorkPercentage(value);

//                             if (alreadyExists) {
//                               alert(`Physical progress ${value}% is already recorded!`);
//                               setIsDisabledSubmit(true);
//                               setPhysicalWorkPercentage('');
//                               return;
//                             }

//                             if (lastProgress === 0 && value !== "30") {
//                               alert("You must start with 30% progress.");
//                               setIsDisabledSubmit(true);
//                               setPhysicalWorkPercentage('');
//                               return;
//                             }
//                             if (lastProgress === 30 && value !== "50") {
//                               alert("After 30%, only 50% is allowed.");
//                               setIsDisabledSubmit(true);
//                               setPhysicalWorkPercentage('');
//                               return;
//                             }
//                             if (lastProgress === 50 && value !== "100") {
//                               alert("After 50%, only 100% is allowed.");
//                               setIsDisabledSubmit(true);
//                               setPhysicalWorkPercentage('');
//                               return;
//                             }
//                             if (lastProgress === 100) {
//                               alert("Work completed (100%). No updates allowed.");
//                               setIsDisabledSubmit(true);
//                               setPhysicalWorkPercentage('');
//                               return;
//                             }

//                             // Valid selection
//                             setIsDisabledSubmit(false);
//                           }}
//                           disabled={!filterTechnicalUID || completedProgress === "100"}
//                         >
//                           <option value="" disabled>Select Physical Progress</option>
//                           <option value="30">30%</option>
//                           <option value="50">50%</option>
//                           <option value="100">100%</option>
//                         </select>

//                       </div>
//                     </div>
//                   </div>

//                   <div className="col-12 elements mb-1 p-0">
//                     <div className="row g-0 p-0 m-0">
//                       <div className="col-3 my-auto">

//                         <label>
//                           {t("Remark")} <span style={{ color: 'red' }}>*</span>
//                         </label>
//                       </div>
//                       <div className="col-7">
//                         <textarea
//                           value={remarks}
//                           onChange={(e) => setRemarks(e.target.value)}
//                           placeholder={t("Enter remarks here...")}
//                           maxLength={100}
//                           className='py-2'
//                           style={{ width: "100%", minHeight: "80px", resize: "vertical" }}
//                           required
//                         />
//                       </div>
//                     </div>
//                   </div>
//                   {filterTechnicalUID && (
//                     <div className="col-12 pb-5 mt-3">
//                       <div className="col-12 mb-3" style={{ backgroundColor: "white", padding: "30px 40px", boxShadow: "0px 0px 5px 1px #E4E8EC", borderRadius: "20px", width: "100%" }}>
//                         <div className='col-12 tableDesign' style={{ background: '#2C78DB', display: 'flex', width: '70vw', overflowX: "auto", border: '1px solid #3b409e', width: '100%' }}>
//                           <table className='m-0 p-0' style={{ width: '100%', borderCollapse: 'collapse' }}>
//                             <thead>
//                               <tr style={{ color: 'white', border: 'none', height: '3rem', fontSize: "12px" }}>
//                                 <th style={headerStyle}>{t("Sr.No")}</th>
//                                 <th style={headerStyle}>{t("Head Code")}</th>
//                                 <th style={headerStyle}>{t("Work Name")}</th>
//                                 <th style={headerStyle}>{t("MHUID Number")}</th>
//                                 <th style={headerStyle}>{t("Financial Year")}</th>
//                                 <th style={headerStyle}>{t("Contractor Name")}</th>
//                                 <th style={headerStyle}>{t("Created Date")}</th>
//                                 <th style={headerStyle}>{t("Upload Photo")}</th>
//                               </tr>
//                             </thead>
//                             <tbody>
//                               {currentBills?.length === 0 ? (
//                                 <tr>
//                                   <td colSpan="8" style={{ textAlign: 'center', padding: '20px', backgroundColor: '#f9f9f9' }}>
//                                     {t("No data available")}
//                                   </td>
//                                 </tr>
//                               ) : (
//                                 currentBills.map((proposal, index) => {
//                                   const bgColor = selectedProposals.includes(proposal.WorkOrderID)
//                                     ? "#B3D9FF"
//                                     : index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
//                                   return (
//                                     <tr
//                                       style={{
//                                         backgroundColor: bgColor,
//                                         fontSize: "12px",
//                                         fontWeight: "500",
//                                         borderBottom: '1px solid #3b409e',
//                                         cursor: 'pointer'
//                                       }}
//                                       key={index}

//                                     >
//                                       <td style={{ padding: '8px 8px' }}>{indexOfFirstBill + index + 1}</td>
//                                       <td style={{ padding: '8px 8px' }}>{proposal.HeadCode}</td>
//                                       <td style={{ padding: '8px 8px' }}>{proposal.WorkName}</td>
//                                       <td style={{ padding: '8px 8px' }}>{proposal.TechnicalUID}</td>
//                                       <td style={{ padding: '8px 8px' }}>{proposal.ProposalYear}</td>
//                                       <td style={{ padding: '8px 8px' }}>{proposal.ContractorName}</td>
//                                       <td style={{ padding: '8px 8px', color: "#0098d5" }}>{new Date(proposal.Date).toLocaleString()}</td>
//                                       <td style={{ padding: '8px 8px' }}>

//                                         <button
//                                           type="button"
//                                           onClick={(e) => {
//                                             e.stopPropagation();

//                                             // Validate required fields before proceeding
//                                             if (!filterHeadCode) {
//                                               alert(t("Please select Head Code (required)!"));
//                                               return;
//                                             }
//                                             if (!filterProposalYear) {
//                                               alert(t("Please select Approval Year (required)!"));
//                                               return;
//                                             }
//                                             if (!filterTechnicalUID) {
//                                               alert(t("Please select MHUID Number (required)!"));
//                                               return;
//                                             }
//                                             if (!filterCommonWorkOrderId) {
//                                               alert(t("Please select Work Order Name (required)!"));
//                                               return;
//                                             }
//                                             if (!physicalWorkPercentage) {
//                                               alert(t("Please select physical work percentage!"));
//                                               return;
//                                             }
//                                             if (!remarks || remarks.trim() === "") {
//                                               alert(t("Please enter remarks!"));
//                                               return;
//                                             }
//                                             if (!declarationChecked) {
//                                               alert(t("Please check the declaration before proceeding!"));
//                                               return;
//                                             }

//                                             // If disabled flag set (existing business rule), show message
//                                             if (isDisabledSubmit) {
//                                               alert(t("This physical progress already exists for the selected MH UID!"));
//                                               return;
//                                             }

//                                             // All good -> select row and open popup
//                                             handleRowClick(proposal.WorkOrderID);
//                                             handleAddClick(proposal);
//                                           }}
//                                           style={{
//                                             backgroundColor: isDisabledSubmit ? "#a0a0a0" : "#2C78DB",
//                                             color: "white",
//                                             border: "none",
//                                             borderRadius: "8px",
//                                             padding: "6px 12px",
//                                             fontSize: "12px",
//                                             fontWeight: "500",
//                                             display: "inline-flex",
//                                             alignItems: "center",
//                                             gap: "4px",
//                                             cursor: isDisabledSubmit ? "not-allowed" : "pointer",
//                                             opacity: isDisabledSubmit ? 0.7 : 1
//                                           }}
//                                         >
//                                           <img
//                                             src="/Upload-Images64.png"
//                                             alt="upload"
//                                             style={{ width: "14px", height: "14px", opacity: 0.8 }}
//                                           />
//                                           {t("Upload")}
//                                         </button>

//                                       </td>
//                                     </tr>
//                                   );
//                                 })
//                               )}
//                             </tbody>
//                           </table>
//                         </div>

//                         {filterCommonWorkOrderId && selectedProposals.length !== 1 && (
//                           <p style={{ fontSize: "12px", color: "red", marginTop: "8px" }}>
//                             {t("Please click on the Upload Button for uploading photos.")}
//                           </p>
//                         )}

//                         {/* Declaration Section */}
//                         <div className="mb-0 mt-5 mb-2">
//                           <p
//                             style={{
//                               fontWeight: "600",
//                               fontSize: "20px",
//                               marginBottom: "4px",
//                               display: "inline",
//                             }}
//                           >
//                             {t("Declaration")}
//                           </p>
//                           <span style={{ color: "red", marginLeft: "4px" }}>*</span>
//                         </div>

//                         <div
//                           style={{
//                             display: "flex",
//                             alignItems: "flex-start",
//                             gap: "10px",
//                             marginBottom: "8px"
//                           }}
//                         >
//                           <div style={{ flexShrink: 0 }}>
//                             <input
//                               type="checkbox"
//                               id="declaration"
//                               checked={declarationChecked}
//                               onChange={(e) => setDeclarationChecked(e.target.checked)}
//                               style={{
//                                 marginTop: "4px",
//                                 transform: "scale(1.2)",
//                                 cursor: "pointer"
//                               }}
//                               required
//                             />
//                           </div>
//                           <label
//                             htmlFor="declaration"
//                             style={{
//                               fontSize: "14px",
//                               lineHeight: "1.6",
//                               textAlign: "justify",
//                               flex: 1
//                             }}
//                           >
//                             {t("I hereby declare that the information provided above and in the enclosed documents is true and correct to the best of my knowledge and belief, and nothing has been concealed. I am fully aware that if any information submitted by me is found to be false or incorrect at any stage, I will be liable for action as per the provisions of law in force, and any benefits received by me may be cancelled immediately.")}
//                           </label>
//                         </div>

//                         <div className='mt-5' style={{ marginTop: '20px' }}>
//                           <h3 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '15px' }}>
//                             {t("Progress Photo Uploaded")}
//                           </h3>
//                           <div style={{
//                             display: 'flex',
//                             gap: '16px',
//                             overflowX: 'auto',
//                             paddingBottom: '10px'
//                           }}>
//                             {selectedImages.length > 0 ? (
//                               selectedImages.map((img, idx) => (
//                                 <div
//                                   key={idx}
//                                   style={{
//                                     border: '1px solid #ddd',
//                                     borderRadius: '8px',
//                                     padding: '12px',
//                                     textAlign: 'center',
//                                     boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
//                                     minWidth: '180px',
//                                     flexShrink: 0
//                                   }}
//                                 >
//                                   <div style={{
//                                     width: '180px',
//                                     height: '180px',
//                                     backgroundColor: '#f3f4f6',
//                                     borderRadius: '4px',
//                                     overflow: 'hidden',
//                                     display: 'flex',
//                                     alignItems: 'center',
//                                     justifyContent: 'center'
//                                   }}>
//                                     <img
//                                       src={URL.createObjectURL(img)}
//                                       alt={`preview-${idx}`}
//                                       style={{
//                                         width: '100%',
//                                         height: '100%',
//                                         objectFit: 'cover',
//                                       }}
//                                     />

//                                   </div>
//                                   <div style={{
//                                     marginTop: '12px',
//                                     fontSize: '14px',
//                                     fontWeight: '600',
//                                     color: '#374151'
//                                   }}>
//                                     {t("Done: ")}{physicalWorkPercentage}%
//                                   </div>
//                                 </div>
//                               ))
//                             ) : (
//                               <p style={{ color: '#6b7280' }}>{t("No progress photos available")}</p>
//                             )}
//                           </div>
//                         </div>

//                         <div className='mt-5'>
//                           <h3 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '15px' }}>
//                             {t("Progress Photos Till Date")}
//                           </h3>

//                           <div
//                             style={{
//                               display: 'flex',
//                               gap: '16px',
//                               overflowX: 'auto',
//                               paddingBottom: '10px'
//                             }}
//                           >
//                             {progressPhoto.length > 0 ? (
//                               progressPhoto.flatMap((photo) =>
//                                 getImageUrls(photo.upload).map((imgUrl, idx) => (
//                                   <div
//                                     key={`${photo.id}-${idx}`}
//                                     style={{
//                                       border: '1px solid #ddd',
//                                       borderRadius: '8px',
//                                       padding: '12px',
//                                       textAlign: 'center',
//                                       boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
//                                       minWidth: '180px',
//                                       flexShrink: 0   // 🔑 IMPORTANT for X-scroll
//                                     }}
//                                   >
//                                     <div
//                                       style={{
//                                         width: '160px',
//                                         height: '160px',
//                                         backgroundColor: '#f3f4f6',
//                                         borderRadius: '6px',
//                                         overflow: 'hidden',
//                                         display: 'flex',
//                                         alignItems: 'center',
//                                         justifyContent: 'center'
//                                       }}
//                                     >
//                                       <img
//                                         src={imgUrl}
//                                         alt={`Progress-${photo.id}-${idx}`}
//                                         style={{
//                                           width: '100%',
//                                           height: '100%',
//                                           objectFit: 'cover'
//                                         }}
//                                         onError={(e) => {
//                                           e.target.src = "/no-image.png";
//                                         }}
//                                       />
//                                     </div>

//                                     <div
//                                       style={{
//                                         marginTop: '10px',
//                                         fontSize: '14px',
//                                         fontWeight: '600',
//                                         color: '#374151'
//                                       }}
//                                     >
//                                       {t("Done: ")}{photo.physicalValue}%
//                                     </div>
//                                   </div>
//                                 ))
//                               )
//                             ) : (
//                               <p style={{ color: '#6b7280' }}>{t("No progress photos available")}</p>
//                             )}
//                           </div>
//                         </div>

//                         <div className='col-12 py-1' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '15px 0' }}>
//                           <p className="text-gray-600" style={{ fontSize: "14px", margin: 0 }}>
//                             {t("Showing")} {filteredBills.length > 0 ? indexOfFirstBill + 1 : 0} {t("to")} {Math.min(indexOfLastBill, filteredBills.length)} {t("of")} {filteredBills?.length} {t("entries")}
//                             {selectedProposals.length > 0 && ` | Selected: ${selectedProposals.length}`}
//                           </p>
//                         </div>
//                       </div>
//                     </div>
//                   )}

//                   <div className="col-12 mt-4" style={{ display: 'flex', justifyContent: "center", alignItems: "center", gap: '15px' }}>
//                     <div >
//                       <button
//                         type="button"
//                         onClick={(e) => {
//                           if (selectedProposals.length !== 1) {
//                             alert(t("Please click on the Upload Button for uploading photos"));
//                             return;
//                           }
//                           if (!selectedImages || selectedImages.length === 0) {
//                             alert(t("Please upload photo"));
//                             return;
//                           }
//                           handlePhotoUpload(e, selectedProposal.WorkName);
//                         }}
//                         style={{
//                           padding: "8px 20px",
//                           backgroundColor: isDisabledSubmit || loading ? "#a0a0a0" : "#007bff",
//                           color: "white",
//                           border: "none",
//                           borderRadius: "8px",
//                           fontSize: "14px",
//                           cursor: isDisabledSubmit || loading ? "not-allowed" : "pointer",
//                           fontWeight: "500",
//                           display: "flex",
//                           alignItems: "center",
//                           gap: "6px",
//                           opacity: isDisabledSubmit || loading ? 0.7 : 1
//                         }}
//                       >
//                         {loading ? (
//                           <>
//                             <div
//                               style={{
//                                 width: "16px",
//                                 height: "16px",
//                                 border: "2px solid white",
//                                 borderTop: "2px solid transparent",
//                                 borderRadius: "50%",
//                                 animation: "spin 0.8s linear infinite",
//                               }}
//                             ></div>
//                             {t("Uploading...")}
//                           </>
//                         ) : (
//                           t("Submit")
//                         )}
//                       </button>
//                     </div>

//                     <div>
//                       <button
//                         type="button"
//                         onClick={clearAllFilters}
//                         style={{
//                           padding: "8px 20px",
//                           backgroundColor: "#dc3545",
//                           color: "white",
//                           border: "none",
//                           borderRadius: "8px",
//                           fontSize: "14px",
//                           cursor: "pointer",
//                           fontWeight: "500",
//                           display: "flex",
//                           alignItems: "center",
//                           gap: "6px"
//                         }}
//                       >
//                         <img src="/Close-32.png" alt="clear" style={{ width: "14px", height: "14px" }} />
//                         {t("Cancel")}
//                       </button>
//                     </div>
//                   </div>

//                 </div>
//               </div>
//             </form>

//             {showPopup && (
//               <div style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "rgba(0,0,0,0.5)", backdropFilter: "blur(4px)", WebkitBackdropFilter: "blur(4px)", display: "flex", justifyContent: "center", alignItems: "center", zIndex: 1000 }}>
//                 <div style={{ backgroundColor: "white", padding: "20px", borderRadius: "10px", width: "500px", maxWidth: "90%", boxShadow: "0px 0px 10px rgba(0,0,0,0.3)" }}>
//                   <h3>{t("Upload Images for Proposal")}</h3>
//                   {selectedProposal && (
//                     <div style={{ marginBottom: "10px" }}>
//                       <p><strong>{t("Head Code:")}</strong> {selectedProposal.HeadCode}</p>
//                       <p><strong>{t("MHUID Number:")}</strong> {selectedProposal.TechnicalUID}</p>
//                       <p><strong>{t("Work Name:")}</strong> {selectedProposal.WorkName}</p>
//                     </div>
//                   )}
//                   <input type="file" accept="image/*" multiple onChange={(e) => { const newFiles = Array.from(e.target.files); setSelectedImages(prev => [...prev, ...newFiles]); }} />
//                   {selectedImages.length > 0 && (
//                     <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: '10px', gap: '10px' }}>
//                       {selectedImages.map((img, idx) => (
//                         <div key={idx} style={{ position: 'relative' }}>
//                           <img src={URL.createObjectURL(img)} alt={`preview-${idx}`} style={{ width: '100px', height: '100px', objectFit: 'cover', borderRadius: '5px', border: '1px solid #ccc' }} />
//                           <button onClick={() => { setSelectedImages(prev => prev.filter((_, i) => i !== idx)); }} style={{ position: 'absolute', top: 0, right: 0, background: 'red', color: 'white', border: 'none', borderRadius: '0 0 0 5px', cursor: 'pointer', fontSize: '12px', padding: '2px 4px' }}>X</button>
//                         </div>
//                       ))}
//                     </div>
//                   )}

//                   <div style={{ marginTop: "15px", display: "flex", justifyContent: "space-between" }}>
//                     <button
//                       style={{ marginTop: '5px', padding: '5px 10px', backgroundColor: 'red', color: 'white', borderRadius: '6px', border: 'none' }}
//                       onClick={() => setShowPopup(false)}
//                     >
//                       {t("Close")}
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>

//       {showDetail && (
//         <div onClick={() => setShowDetail(null)} style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', backgroundColor: 'rgba(0, 0, 0, 0.84)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999 }}>
//           <div onClick={(e) => e.stopPropagation()} style={{ backgroundColor: 'white', padding: '40px 40px', borderRadius: '20px', width: '50%', maxHeight: '90vh', overflow: "hidden", boxShadow: '0 2px 10px rgba(0,0,0,0.3)', position: 'relative' }}>
//             <div className="col-12">
//               <div className="col-12 mb-3">
//                 <div className="row">
//                   <div className="col-6">
//                     <h5 className='fw-bold'>{t("Proposal Details")}</h5>
//                   </div>
//                   <div className="col-6" style={{ display: 'flex', justifyContent: 'flex-end' }}>
//                     <button onClick={() => setShowDetail(null)} style={{ width: '32px', height: '32px', borderRadius: '50%', backgroundColor: 'red', border: 'none', display: 'flex', justifyContent: 'center', alignItems: "center", cursor: 'pointer', fontSize: '24px', fontWeight: 'bold', color: 'white', lineHeight: 1 }}>×</button>
//                   </div>
//                 </div>
//               </div>
//               <div className="col-12" style={{ height: "59vh", overflowX: "hidden", overflowY: "scroll", scrollBehavior: "smooth" }}>
//                 <table style={{ width: '100%', height: "100%", borderCollapse: 'collapse' }}>
//                   <tbody>
//                     {Object.entries(showDetail).map(([key, value], index) => (
//                       <tr key={key} style={{ backgroundColor: index % 2 === 0 ? '#2B75D5' : '#cce0f9', border: '1px solid #cce0f9' }}>
//                         <td style={{ fontWeight: 'bold', padding: '8px 8px', width: '40%', backgroundColor: '#2B75D5', color: 'white', border: '1px solid #cce0f9' }}>{key}</td>
//                         <td style={{ padding: '8px 8px', color: "black", backgroundColor: index % 2 === 0 ? '#E3EBF5' : '#D0DEF1' }}>
//                           {key === 'Copy of Work Order' && value ? (
//                             <a href={`${apiurl}/uploads/${value}`} target="_blank" rel="noreferrer">{value}</a>
//                           ) : value === null || value === '' ? '-' : value.toString()}
//                         </td>
//                       </tr>
//                     ))}
//                   </tbody>
//                 </table>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default ProgressReport;
